const AWS_S3 = [
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "us-west-1",
    ResourceArn:
      "arn:aws:s3:::montycloud-inventorybucketdatasync-700953207471-0",
    ResourceId: "montycloud-inventorybucketdatasync-700953207471-0",
    ResourceType: "aws.s3.bucket",
    ServiceName: "Amazon Simple Storage Service",
    TotalCost: 114.2,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "af-south-1",
    ResourceArn:
      "arn:aws:s3:::montycloud-inventorybucketdatasync-700953207471-1",
    ResourceId: "montycloud-inventorybucketdatasync-700953207471-1",
    ResourceType: "aws.s3.bucket",
    ServiceName: "Amazon Simple Storage Service",
    TotalCost: 114.2,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "ap-southeast-2",
    ResourceArn:
      "arn:aws:s3:::montycloud-inventorybucketdatasync-700953207471-2",
    ResourceId: "montycloud-inventorybucketdatasync-700953207471-2",
    ResourceType: "aws.s3.bucket",
    ServiceName: "Amazon Simple Storage Service",
    TotalCost: 114.2,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "eu-west-1",
    ResourceArn:
      "arn:aws:s3:::montycloud-inventorybucketdatasync-700953207471-3",
    ResourceId: "montycloud-inventorybucketdatasync-700953207471-3",
    ResourceType: "aws.s3.bucket",
    ServiceName: "Amazon Simple Storage Service",
    TotalCost: 114.2,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "ap-northeast-3",
    ResourceArn:
      "arn:aws:s3:::montycloud-inventorybucketdatasync-700953207471-4",
    ResourceId: "montycloud-inventorybucketdatasync-700953207471-4",
    ResourceType: "aws.s3.bucket",
    ServiceName: "Amazon Simple Storage Service",
    TotalCost: 114.2,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "ap-northeast-1",
    ResourceArn:
      "arn:aws:s3:::montycloud-inventorybucketdatasync-700953207471-5",
    ResourceId: "montycloud-inventorybucketdatasync-700953207471-5",
    ResourceType: "aws.s3.bucket",
    ServiceName: "Amazon Simple Storage Service",
    TotalCost: 114.2,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "ap-northeast-1",
    ResourceArn:
      "arn:aws:s3:::montycloud-inventorybucketdatasync-700953207471-6",
    ResourceId: "montycloud-inventorybucketdatasync-700953207471-6",
    ResourceType: "aws.s3.bucket",
    ServiceName: "Amazon Simple Storage Service",
    TotalCost: 114.2,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: false,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "eu-west-1",
    ResourceArn:
      "arn:aws:s3:::montycloud-inventorybucketdatasync-700953207471-7",
    ResourceId: "montycloud-inventorybucketdatasync-700953207471-7",
    ResourceType: "aws.s3.bucket",
    ServiceName: "Amazon Simple Storage Service",
    TotalCost: 114.2,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: false,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "us-east-2",
    ResourceArn:
      "arn:aws:s3:::montycloud-inventorybucketdatasync-700953207471-8",
    ResourceId: "montycloud-inventorybucketdatasync-700953207471-8",
    ResourceType: "aws.s3.bucket",
    ServiceName: "Amazon Simple Storage Service",
    TotalCost: 114.2,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: false,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "us-east-1",
    ResourceArn:
      "arn:aws:s3:::montycloud-inventorybucketdatasync-700953207471-9",
    ResourceId: "montycloud-inventorybucketdatasync-700953207471-9",
    ResourceType: "aws.s3.bucket",
    ServiceName: "Amazon Simple Storage Service",
    TotalCost: 114.2,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: false,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "ap-south-1",
    ResourceArn:
      "arn:aws:s3:::montycloud-inventorybucketdatasync-700953207471-10",
    ResourceId: "montycloud-inventorybucketdatasync-700953207471-10",
    ResourceType: "aws.s3.bucket",
    ServiceName: "Amazon Simple Storage Service",
    TotalCost: 114.2,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: false,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "ap-northeast-1",
    ResourceArn:
      "arn:aws:s3:::montycloud-inventorybucketdatasync-700953207471-11",
    ResourceId: "montycloud-inventorybucketdatasync-700953207471-11",
    ResourceType: "aws.s3.bucket",
    ServiceName: "Amazon Simple Storage Service",
    TotalCost: 114.2,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: false,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "ap-east-1",
    ResourceArn:
      "arn:aws:s3:::montycloud-inventorybucketdatasync-700953207471-12",
    ResourceId: "montycloud-inventorybucketdatasync-700953207471-12",
    ResourceType: "aws.s3.bucket",
    ServiceName: "Amazon Simple Storage Service",
    TotalCost: 114.2,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: false,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "us-east-1",
    ResourceArn:
      "arn:aws:s3:::montycloud-inventorybucketdatasync-700953207471-13",
    ResourceId: "montycloud-inventorybucketdatasync-700953207471-13",
    ResourceType: "aws.s3.bucket",
    ServiceName: "Amazon Simple Storage Service",
    TotalCost: 114.2,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: false,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "ap-southeast-1",
    ResourceArn:
      "arn:aws:s3:::montycloud-inventorybucketdatasync-700953207471-14",
    ResourceId: "montycloud-inventorybucketdatasync-700953207471-14",
    ResourceType: "aws.s3.bucket",
    ServiceName: "Amazon Simple Storage Service",
    TotalCost: 114.2,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: false,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "us-west-1",
    ResourceArn:
      "arn:aws:s3:::montycloud-inventorybucketdatasync-700953207471-15",
    ResourceId: "montycloud-inventorybucketdatasync-700953207471-15",
    ResourceType: "aws.s3.bucket",
    ServiceName: "Amazon Simple Storage Service",
    TotalCost: 114.2,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: false,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "us-east-2",
    ResourceArn:
      "arn:aws:s3:::montycloud-inventorybucketdatasync-700953207471-16",
    ResourceId: "montycloud-inventorybucketdatasync-700953207471-16",
    ResourceType: "aws.s3.bucket",
    ServiceName: "Amazon Simple Storage Service",
    TotalCost: 114.2,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: false,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "us-east-2",
    ResourceArn:
      "arn:aws:s3:::montycloud-inventorybucketdatasync-700953207471-17",
    ResourceId: "montycloud-inventorybucketdatasync-700953207471-17",
    ResourceType: "aws.s3.bucket",
    ServiceName: "Amazon Simple Storage Service",
    TotalCost: 114.2,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: false,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "us-east-2",
    ResourceArn:
      "arn:aws:s3:::montycloud-inventorybucketdatasync-700953207471-18",
    ResourceId: "montycloud-inventorybucketdatasync-700953207471-18",
    ResourceType: "aws.s3.bucket",
    ServiceName: "Amazon Simple Storage Service",
    TotalCost: 114.2,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: false,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "eu-west-2",
    ResourceArn:
      "arn:aws:s3:::montycloud-inventorybucketdatasync-700953207471-19",
    ResourceId: "montycloud-inventorybucketdatasync-700953207471-19",
    ResourceType: "aws.s3.bucket",
    ServiceName: "Amazon Simple Storage Service",
    TotalCost: 114.2,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: false,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "ap-east-1",
    ResourceArn:
      "arn:aws:s3:::montycloud-inventorybucketdatasync-700953207471-20",
    ResourceId: "montycloud-inventorybucketdatasync-700953207471-20",
    ResourceType: "aws.s3.bucket",
    ServiceName: "Amazon Simple Storage Service",
    TotalCost: 114.2,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: false,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "ap-southeast-2",
    ResourceArn:
      "arn:aws:s3:::montycloud-inventorybucketdatasync-700953207471-21",
    ResourceId: "montycloud-inventorybucketdatasync-700953207471-21",
    ResourceType: "aws.s3.bucket",
    ServiceName: "Amazon Simple Storage Service",
    TotalCost: 114.2,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: false,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "us-west-2",
    ResourceArn:
      "arn:aws:s3:::montycloud-inventorybucketdatasync-700953207471-22",
    ResourceId: "montycloud-inventorybucketdatasync-700953207471-22",
    ResourceType: "aws.s3.bucket",
    ServiceName: "Amazon Simple Storage Service",
    TotalCost: 114.2,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
];

const AWS_Security_Hub = [
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "us-west-2",
    ResourceArn: "arn:aws:securityhub:us-east-1:700953207471:hub/default-0",
    ResourceId: "arn:aws:securityhub:us-east-1:700953207471:hub/default-0",
    ResourceType: "aws.securityhub.hub",
    ServiceName: "AWS Security Hub",
    TotalCost: 200,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: false,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "eu-west-3",
    ResourceArn: "arn:aws:securityhub:us-east-1:700953207471:hub/default-1",
    ResourceId: "arn:aws:securityhub:us-east-1:700953207471:hub/default-1",
    ResourceType: "aws.securityhub.hub",
    ServiceName: "AWS Security Hub",
    TotalCost: 200,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: false,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "ap-southeast-2",
    ResourceArn: "arn:aws:securityhub:us-east-1:700953207471:hub/default-2",
    ResourceId: "arn:aws:securityhub:us-east-1:700953207471:hub/default-2",
    ResourceType: "aws.securityhub.hub",
    ServiceName: "AWS Security Hub",
    TotalCost: 200,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
];

const FSX = [
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "ap-southeast-2",
    ResourceArn:
      "arn:aws:fsx:us-east-1:700953207471:backup/backup-020d3c3e3185ef67b-0",
    ResourceId:
      "arn:aws:fsx:us-east-1:700953207471:backup/backup-020d3c3e3185ef67b-0",
    ResourceType: "aws.fsx.backup",
    ServiceName: "Amazon FSx",
    TotalCost: 275,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "us-east-1",
    ResourceArn:
      "arn:aws:fsx:us-east-1:700953207471:backup/backup-020d3c3e3185ef67b-1",
    ResourceId:
      "arn:aws:fsx:us-east-1:700953207471:backup/backup-020d3c3e3185ef67b-1",
    ResourceType: "aws.fsx.backup",
    ServiceName: "Amazon FSx",
    TotalCost: 275,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "eu-west-3",
    ResourceArn:
      "arn:aws:fsx:us-east-1:700953207471:backup/backup-020d3c3e3185ef67b-2",
    ResourceId:
      "arn:aws:fsx:us-east-1:700953207471:backup/backup-020d3c3e3185ef67b-2",
    ResourceType: "aws.fsx.backup",
    ServiceName: "Amazon FSx",
    TotalCost: 275,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "ap-east-1",
    ResourceArn:
      "arn:aws:fsx:us-east-1:700953207471:backup/backup-020d3c3e3185ef67b-3",
    ResourceId:
      "arn:aws:fsx:us-east-1:700953207471:backup/backup-020d3c3e3185ef67b-3",
    ResourceType: "aws.fsx.backup",
    ServiceName: "Amazon FSx",
    TotalCost: 275,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: false,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "us-west-2",
    ResourceArn:
      "arn:aws:fsx:us-east-1:700953207471:backup/backup-020d3c3e3185ef67b-4",
    ResourceId:
      "arn:aws:fsx:us-east-1:700953207471:backup/backup-020d3c3e3185ef67b-4",
    ResourceType: "aws.fsx.backup",
    ServiceName: "Amazon FSx",
    TotalCost: 275,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: false,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "eu-south-1",
    ResourceArn:
      "arn:aws:fsx:us-east-1:700953207471:backup/backup-020d3c3e3185ef67b-5",
    ResourceId:
      "arn:aws:fsx:us-east-1:700953207471:backup/backup-020d3c3e3185ef67b-5",
    ResourceType: "aws.fsx.backup",
    ServiceName: "Amazon FSx",
    TotalCost: 275,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: false,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "us-east-1",
    ResourceArn:
      "arn:aws:fsx:us-east-1:700953207471:backup/backup-020d3c3e3185ef67b-6",
    ResourceId:
      "arn:aws:fsx:us-east-1:700953207471:backup/backup-020d3c3e3185ef67b-6",
    ResourceType: "aws.fsx.backup",
    ServiceName: "Amazon FSx",
    TotalCost: 275,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: false,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "ap-northeast-2",
    ResourceArn:
      "arn:aws:fsx:us-east-1:700953207471:backup/backup-020d3c3e3185ef67b-7",
    ResourceId:
      "arn:aws:fsx:us-east-1:700953207471:backup/backup-020d3c3e3185ef67b-7",
    ResourceType: "aws.fsx.backup",
    ServiceName: "Amazon FSx",
    TotalCost: 275,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: false,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "us-west-1",
    ResourceArn:
      "arn:aws:fsx:us-east-1:700953207471:backup/backup-020d3c3e3185ef67b-8",
    ResourceId:
      "arn:aws:fsx:us-east-1:700953207471:backup/backup-020d3c3e3185ef67b-8",
    ResourceType: "aws.fsx.backup",
    ServiceName: "Amazon FSx",
    TotalCost: 275,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: false,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "eu-west-1",
    ResourceArn:
      "arn:aws:fsx:us-east-1:700953207471:backup/backup-020d3c3e3185ef67b-9",
    ResourceId:
      "arn:aws:fsx:us-east-1:700953207471:backup/backup-020d3c3e3185ef67b-9",
    ResourceType: "aws.fsx.backup",
    ServiceName: "Amazon FSx",
    TotalCost: 275,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: false,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "us-west-1",
    ResourceArn:
      "arn:aws:fsx:us-east-1:700953207471:backup/backup-020d3c3e3185ef67b-10",
    ResourceId:
      "arn:aws:fsx:us-east-1:700953207471:backup/backup-020d3c3e3185ef67b-10",
    ResourceType: "aws.fsx.backup",
    ServiceName: "Amazon FSx",
    TotalCost: 275,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
];

const AWS_ECS_Kubernetes = [
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "ap-northeast-1",
    ResourceArn:
      "arn:aws:eks:us-east-1:700953207471:cluster/sample-eks-cluster-0",
    ResourceId:
      "arn:aws:eks:us-east-1:700953207471:cluster/sample-eks-cluster-0",
    ResourceType: "aws.eks.cluster",
    ServiceName: "Amazon Elastic Container Service for Kubernetes",
    TotalCost: 220,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "ap-northeast-1",
    ResourceArn:
      "arn:aws:eks:us-east-1:700953207471:cluster/sample-eks-cluster-1",
    ResourceId:
      "arn:aws:eks:us-east-1:700953207471:cluster/sample-eks-cluster-1",
    ResourceType: "aws.eks.cluster",
    ServiceName: "Amazon Elastic Container Service for Kubernetes",
    TotalCost: 220,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "us-west-1",
    ResourceArn:
      "arn:aws:eks:us-east-1:700953207471:cluster/sample-eks-cluster-2",
    ResourceId:
      "arn:aws:eks:us-east-1:700953207471:cluster/sample-eks-cluster-2",
    ResourceType: "aws.eks.cluster",
    ServiceName: "Amazon Elastic Container Service for Kubernetes",
    TotalCost: 220,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "sa-east-1",
    ResourceArn:
      "arn:aws:eks:us-east-1:700953207471:cluster/sample-eks-cluster-3",
    ResourceId:
      "arn:aws:eks:us-east-1:700953207471:cluster/sample-eks-cluster-3",
    ResourceType: "aws.eks.cluster",
    ServiceName: "Amazon Elastic Container Service for Kubernetes",
    TotalCost: 220,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "eu-south-1",
    ResourceArn:
      "arn:aws:eks:us-east-1:700953207471:cluster/sample-eks-cluster-4",
    ResourceId:
      "arn:aws:eks:us-east-1:700953207471:cluster/sample-eks-cluster-4",
    ResourceType: "aws.eks.cluster",
    ServiceName: "Amazon Elastic Container Service for Kubernetes",
    TotalCost: 220,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "me-south-1",
    ResourceArn:
      "arn:aws:eks:us-east-1:700953207471:cluster/sample-eks-cluster-5",
    ResourceId:
      "arn:aws:eks:us-east-1:700953207471:cluster/sample-eks-cluster-5",
    ResourceType: "aws.eks.cluster",
    ServiceName: "Amazon Elastic Container Service for Kubernetes",
    TotalCost: 220,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "ap-northeast-3",
    ResourceArn:
      "arn:aws:eks:us-east-1:700953207471:cluster/sample-eks-cluster-6",
    ResourceId:
      "arn:aws:eks:us-east-1:700953207471:cluster/sample-eks-cluster-6",
    ResourceType: "aws.eks.cluster",
    ServiceName: "Amazon Elastic Container Service for Kubernetes",
    TotalCost: 220,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "ap-southeast-1",
    ResourceArn:
      "arn:aws:eks:us-east-1:700953207471:cluster/sample-eks-cluster-7",
    ResourceId:
      "arn:aws:eks:us-east-1:700953207471:cluster/sample-eks-cluster-7",
    ResourceType: "aws.eks.cluster",
    ServiceName: "Amazon Elastic Container Service for Kubernetes",
    TotalCost: 220,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "us-west-1",
    ResourceArn:
      "arn:aws:eks:us-east-1:700953207471:cluster/sample-eks-cluster-8",
    ResourceId:
      "arn:aws:eks:us-east-1:700953207471:cluster/sample-eks-cluster-8",
    ResourceType: "aws.eks.cluster",
    ServiceName: "Amazon Elastic Container Service for Kubernetes",
    TotalCost: 220,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "eu-central-1",
    ResourceArn:
      "arn:aws:eks:us-east-1:700953207471:cluster/sample-eks-cluster-9",
    ResourceId:
      "arn:aws:eks:us-east-1:700953207471:cluster/sample-eks-cluster-9",
    ResourceType: "aws.eks.cluster",
    ServiceName: "Amazon Elastic Container Service for Kubernetes",
    TotalCost: 220,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: false,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "ap-northeast-3",
    ResourceArn:
      "arn:aws:eks:us-east-1:700953207471:cluster/sample-eks-cluster-10",
    ResourceId:
      "arn:aws:eks:us-east-1:700953207471:cluster/sample-eks-cluster-10",
    ResourceType: "aws.eks.cluster",
    ServiceName: "Amazon Elastic Container Service for Kubernetes",
    TotalCost: 220,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: false,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "eu-central-1",
    ResourceArn:
      "arn:aws:eks:us-east-1:700953207471:cluster/sample-eks-cluster-11",
    ResourceId:
      "arn:aws:eks:us-east-1:700953207471:cluster/sample-eks-cluster-11",
    ResourceType: "aws.eks.cluster",
    ServiceName: "Amazon Elastic Container Service for Kubernetes",
    TotalCost: 220,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
];

const AWS_ECS = [
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "ap-northeast-1",
    ResourceArn:
      "arn:aws:ecs:us-east-1:700953207471:task/warf-test-ecs-cluster-nc/0296f186757e4766b8bd54d8339505a0-0",
    ResourceId:
      "arn:aws:ecs:us-east-1:700953207471:task/warf-test-ecs-cluster-nc/0296f186757e4766b8bd54d8339505a0-0",
    ResourceType: "aws.ecs.task",
    ServiceName: "Amazon Elastic Container Service",
    TotalCost: 125,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "ap-south-1",
    ResourceArn:
      "arn:aws:ecs:us-east-1:700953207471:task/warf-test-ecs-cluster-nc/0296f186757e4766b8bd54d8339505a0-1",
    ResourceId:
      "arn:aws:ecs:us-east-1:700953207471:task/warf-test-ecs-cluster-nc/0296f186757e4766b8bd54d8339505a0-1",
    ResourceType: "aws.ecs.task",
    ServiceName: "Amazon Elastic Container Service",
    TotalCost: 125,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "eu-west-2",
    ResourceArn:
      "arn:aws:ecs:us-east-1:700953207471:task/warf-test-ecs-cluster-nc/0296f186757e4766b8bd54d8339505a0-2",
    ResourceId:
      "arn:aws:ecs:us-east-1:700953207471:task/warf-test-ecs-cluster-nc/0296f186757e4766b8bd54d8339505a0-2",
    ResourceType: "aws.ecs.task",
    ServiceName: "Amazon Elastic Container Service",
    TotalCost: 125,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "ap-southeast-2",
    ResourceArn:
      "arn:aws:ecs:us-east-1:700953207471:task/warf-test-ecs-cluster-nc/0296f186757e4766b8bd54d8339505a0-3",
    ResourceId:
      "arn:aws:ecs:us-east-1:700953207471:task/warf-test-ecs-cluster-nc/0296f186757e4766b8bd54d8339505a0-3",
    ResourceType: "aws.ecs.task",
    ServiceName: "Amazon Elastic Container Service",
    TotalCost: 125,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "eu-north-1",
    ResourceArn:
      "arn:aws:ecs:us-east-1:700953207471:task/warf-test-ecs-cluster-nc/0296f186757e4766b8bd54d8339505a0-4",
    ResourceId:
      "arn:aws:ecs:us-east-1:700953207471:task/warf-test-ecs-cluster-nc/0296f186757e4766b8bd54d8339505a0-4",
    ResourceType: "aws.ecs.task",
    ServiceName: "Amazon Elastic Container Service",
    TotalCost: 125,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "ap-northeast-3",
    ResourceArn:
      "arn:aws:ecs:us-east-1:700953207471:task/warf-test-ecs-cluster-nc/0296f186757e4766b8bd54d8339505a0-5",
    ResourceId:
      "arn:aws:ecs:us-east-1:700953207471:task/warf-test-ecs-cluster-nc/0296f186757e4766b8bd54d8339505a0-5",
    ResourceType: "aws.ecs.task",
    ServiceName: "Amazon Elastic Container Service",
    TotalCost: 125,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "ca-central-1",
    ResourceArn:
      "arn:aws:ecs:us-east-1:700953207471:task/warf-test-ecs-cluster-nc/0296f186757e4766b8bd54d8339505a0-6",
    ResourceId:
      "arn:aws:ecs:us-east-1:700953207471:task/warf-test-ecs-cluster-nc/0296f186757e4766b8bd54d8339505a0-6",
    ResourceType: "aws.ecs.task",
    ServiceName: "Amazon Elastic Container Service",
    TotalCost: 125,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "eu-west-2",
    ResourceArn:
      "arn:aws:ecs:us-east-1:700953207471:task/warf-test-ecs-cluster-nc/0296f186757e4766b8bd54d8339505a0-7",
    ResourceId:
      "arn:aws:ecs:us-east-1:700953207471:task/warf-test-ecs-cluster-nc/0296f186757e4766b8bd54d8339505a0-7",
    ResourceType: "aws.ecs.task",
    ServiceName: "Amazon Elastic Container Service",
    TotalCost: 125,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "ap-south-1",
    ResourceArn:
      "arn:aws:ecs:us-east-1:700953207471:task/warf-test-ecs-cluster-nc/0296f186757e4766b8bd54d8339505a0-8",
    ResourceId:
      "arn:aws:ecs:us-east-1:700953207471:task/warf-test-ecs-cluster-nc/0296f186757e4766b8bd54d8339505a0-8",
    ResourceType: "aws.ecs.task",
    ServiceName: "Amazon Elastic Container Service",
    TotalCost: 125,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "ap-east-1",
    ResourceArn:
      "arn:aws:ecs:us-east-1:700953207471:task/warf-test-ecs-cluster-nc/0296f186757e4766b8bd54d8339505a0-9",
    ResourceId:
      "arn:aws:ecs:us-east-1:700953207471:task/warf-test-ecs-cluster-nc/0296f186757e4766b8bd54d8339505a0-9",
    ResourceType: "aws.ecs.task",
    ServiceName: "Amazon Elastic Container Service",
    TotalCost: 125,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "us-east-2",
    ResourceArn:
      "arn:aws:ecs:us-east-1:700953207471:task/warf-test-ecs-cluster-nc/0296f186757e4766b8bd54d8339505a0-10",
    ResourceId:
      "arn:aws:ecs:us-east-1:700953207471:task/warf-test-ecs-cluster-nc/0296f186757e4766b8bd54d8339505a0-10",
    ResourceType: "aws.ecs.task",
    ServiceName: "Amazon Elastic Container Service",
    TotalCost: 125,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "ap-east-1",
    ResourceArn:
      "arn:aws:ecs:us-east-1:700953207471:task/warf-test-ecs-cluster-nc/0296f186757e4766b8bd54d8339505a0-11",
    ResourceId:
      "arn:aws:ecs:us-east-1:700953207471:task/warf-test-ecs-cluster-nc/0296f186757e4766b8bd54d8339505a0-11",
    ResourceType: "aws.ecs.task",
    ServiceName: "Amazon Elastic Container Service",
    TotalCost: 125,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: false,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "eu-west-1",
    ResourceArn:
      "arn:aws:ecs:us-east-1:700953207471:task/warf-test-ecs-cluster-nc/0296f186757e4766b8bd54d8339505a0-12",
    ResourceId:
      "arn:aws:ecs:us-east-1:700953207471:task/warf-test-ecs-cluster-nc/0296f186757e4766b8bd54d8339505a0-12",
    ResourceType: "aws.ecs.task",
    ServiceName: "Amazon Elastic Container Service",
    TotalCost: 125,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: false,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "eu-west-2",
    ResourceArn:
      "arn:aws:ecs:us-east-1:700953207471:task/warf-test-ecs-cluster-nc/0296f186757e4766b8bd54d8339505a0-13",
    ResourceId:
      "arn:aws:ecs:us-east-1:700953207471:task/warf-test-ecs-cluster-nc/0296f186757e4766b8bd54d8339505a0-13",
    ResourceType: "aws.ecs.task",
    ServiceName: "Amazon Elastic Container Service",
    TotalCost: 125,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: false,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "ap-southeast-1",
    ResourceArn:
      "arn:aws:ecs:us-east-1:700953207471:task/warf-test-ecs-cluster-nc/0296f186757e4766b8bd54d8339505a0-14",
    ResourceId:
      "arn:aws:ecs:us-east-1:700953207471:task/warf-test-ecs-cluster-nc/0296f186757e4766b8bd54d8339505a0-14",
    ResourceType: "aws.ecs.task",
    ServiceName: "Amazon Elastic Container Service",
    TotalCost: 125,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: false,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "ap-southeast-3",
    ResourceArn:
      "arn:aws:ecs:us-east-1:700953207471:task/warf-test-ecs-cluster-nc/0296f186757e4766b8bd54d8339505a0-15",
    ResourceId:
      "arn:aws:ecs:us-east-1:700953207471:task/warf-test-ecs-cluster-nc/0296f186757e4766b8bd54d8339505a0-15",
    ResourceType: "aws.ecs.task",
    ServiceName: "Amazon Elastic Container Service",
    TotalCost: 125,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: false,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "ap-east-1",
    ResourceArn:
      "arn:aws:ecs:us-east-1:700953207471:task/warf-test-ecs-cluster-nc/0296f186757e4766b8bd54d8339505a0-16",
    ResourceId:
      "arn:aws:ecs:us-east-1:700953207471:task/warf-test-ecs-cluster-nc/0296f186757e4766b8bd54d8339505a0-16",
    ResourceType: "aws.ecs.task",
    ServiceName: "Amazon Elastic Container Service",
    TotalCost: 125,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: false,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "sa-east-1",
    ResourceArn:
      "arn:aws:ecs:us-east-1:700953207471:task/warf-test-ecs-cluster-nc/0296f186757e4766b8bd54d8339505a0-17",
    ResourceId:
      "arn:aws:ecs:us-east-1:700953207471:task/warf-test-ecs-cluster-nc/0296f186757e4766b8bd54d8339505a0-17",
    ResourceType: "aws.ecs.task",
    ServiceName: "Amazon Elastic Container Service",
    TotalCost: 125,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: false,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "ap-northeast-3",
    ResourceArn:
      "arn:aws:ecs:us-east-1:700953207471:task/warf-test-ecs-cluster-nc/0296f186757e4766b8bd54d8339505a0-18",
    ResourceId:
      "arn:aws:ecs:us-east-1:700953207471:task/warf-test-ecs-cluster-nc/0296f186757e4766b8bd54d8339505a0-18",
    ResourceType: "aws.ecs.task",
    ServiceName: "Amazon Elastic Container Service",
    TotalCost: 125,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: false,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "us-west-1",
    ResourceArn:
      "arn:aws:ecs:us-east-1:700953207471:task/warf-test-ecs-cluster-nc/0296f186757e4766b8bd54d8339505a0-19",
    ResourceId:
      "arn:aws:ecs:us-east-1:700953207471:task/warf-test-ecs-cluster-nc/0296f186757e4766b8bd54d8339505a0-19",
    ResourceType: "aws.ecs.task",
    ServiceName: "Amazon Elastic Container Service",
    TotalCost: 125,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: false,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "ap-northeast-1",
    ResourceArn:
      "arn:aws:ecs:us-east-1:700953207471:task/warf-test-ecs-cluster-nc/0296f186757e4766b8bd54d8339505a0-20",
    ResourceId:
      "arn:aws:ecs:us-east-1:700953207471:task/warf-test-ecs-cluster-nc/0296f186757e4766b8bd54d8339505a0-20",
    ResourceType: "aws.ecs.task",
    ServiceName: "Amazon Elastic Container Service",
    TotalCost: 125,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: false,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "us-east-2",
    ResourceArn:
      "arn:aws:ecs:us-east-1:700953207471:task/warf-test-ecs-cluster-nc/0296f186757e4766b8bd54d8339505a0-21",
    ResourceId:
      "arn:aws:ecs:us-east-1:700953207471:task/warf-test-ecs-cluster-nc/0296f186757e4766b8bd54d8339505a0-21",
    ResourceType: "aws.ecs.task",
    ServiceName: "Amazon Elastic Container Service",
    TotalCost: 125,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: false,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "us-east-1",
    ResourceArn:
      "arn:aws:ecs:us-east-1:700953207471:task/warf-test-ecs-cluster-nc/0296f186757e4766b8bd54d8339505a0-22",
    ResourceId:
      "arn:aws:ecs:us-east-1:700953207471:task/warf-test-ecs-cluster-nc/0296f186757e4766b8bd54d8339505a0-22",
    ResourceType: "aws.ecs.task",
    ServiceName: "Amazon Elastic Container Service",
    TotalCost: 125,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: false,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "us-east-1",
    ResourceArn:
      "arn:aws:ecs:us-east-1:700953207471:task/warf-test-ecs-cluster-nc/0296f186757e4766b8bd54d8339505a0-23",
    ResourceId:
      "arn:aws:ecs:us-east-1:700953207471:task/warf-test-ecs-cluster-nc/0296f186757e4766b8bd54d8339505a0-23",
    ResourceType: "aws.ecs.task",
    ServiceName: "Amazon Elastic Container Service",
    TotalCost: 125,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: false,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "ca-central-1",
    ResourceArn:
      "arn:aws:ecs:us-east-1:700953207471:task/warf-test-ecs-cluster-nc/0296f186757e4766b8bd54d8339505a0-24",
    ResourceId:
      "arn:aws:ecs:us-east-1:700953207471:task/warf-test-ecs-cluster-nc/0296f186757e4766b8bd54d8339505a0-24",
    ResourceType: "aws.ecs.task",
    ServiceName: "Amazon Elastic Container Service",
    TotalCost: 125,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: false,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "eu-west-2",
    ResourceArn:
      "arn:aws:ecs:us-east-1:700953207471:task/warf-test-ecs-cluster-nc/0296f186757e4766b8bd54d8339505a0-25",
    ResourceId:
      "arn:aws:ecs:us-east-1:700953207471:task/warf-test-ecs-cluster-nc/0296f186757e4766b8bd54d8339505a0-25",
    ResourceType: "aws.ecs.task",
    ServiceName: "Amazon Elastic Container Service",
    TotalCost: 125,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: false,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "ap-southeast-2",
    ResourceArn:
      "arn:aws:ecs:us-east-1:700953207471:task/warf-test-ecs-cluster-nc/0296f186757e4766b8bd54d8339505a0-26",
    ResourceId:
      "arn:aws:ecs:us-east-1:700953207471:task/warf-test-ecs-cluster-nc/0296f186757e4766b8bd54d8339505a0-26",
    ResourceType: "aws.ecs.task",
    ServiceName: "Amazon Elastic Container Service",
    TotalCost: 125,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: false,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "af-south-1",
    ResourceArn:
      "arn:aws:ecs:us-east-1:700953207471:task/warf-test-ecs-cluster-nc/0296f186757e4766b8bd54d8339505a0-27",
    ResourceId:
      "arn:aws:ecs:us-east-1:700953207471:task/warf-test-ecs-cluster-nc/0296f186757e4766b8bd54d8339505a0-27",
    ResourceType: "aws.ecs.task",
    ServiceName: "Amazon Elastic Container Service",
    TotalCost: 125,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: false,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "eu-west-1",
    ResourceArn:
      "arn:aws:ecs:us-east-1:700953207471:task/warf-test-ecs-cluster-nc/0296f186757e4766b8bd54d8339505a0-28",
    ResourceId:
      "arn:aws:ecs:us-east-1:700953207471:task/warf-test-ecs-cluster-nc/0296f186757e4766b8bd54d8339505a0-28",
    ResourceType: "aws.ecs.task",
    ServiceName: "Amazon Elastic Container Service",
    TotalCost: 125,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: false,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "ap-southeast-1",
    ResourceArn:
      "arn:aws:ecs:us-east-1:700953207471:task/warf-test-ecs-cluster-nc/0296f186757e4766b8bd54d8339505a0-29",
    ResourceId:
      "arn:aws:ecs:us-east-1:700953207471:task/warf-test-ecs-cluster-nc/0296f186757e4766b8bd54d8339505a0-29",
    ResourceType: "aws.ecs.task",
    ServiceName: "Amazon Elastic Container Service",
    TotalCost: 125,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
];

const networkFirewall = [
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "eu-central-1",
    ResourceArn: "null-0",
    ResourceId:
      "arn:aws:network-firewall:us-east-1:700953207471:firewall/myFirewall-0",
    ResourceType: null,
    ServiceName: "AWS Network Firewall",
    TotalCost: 200,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "ap-south-1",
    ResourceArn: "null-1",
    ResourceId:
      "arn:aws:network-firewall:us-east-1:700953207471:firewall/myFirewall-1",
    ResourceType: null,
    ServiceName: "AWS Network Firewall",
    TotalCost: 200,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "us-west-1",
    ResourceArn: "null-2",
    ResourceId:
      "arn:aws:network-firewall:us-east-1:700953207471:firewall/myFirewall-2",
    ResourceType: null,
    ServiceName: "AWS Network Firewall",
    TotalCost: 200,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "me-south-1",
    ResourceArn: "null-3",
    ResourceId:
      "arn:aws:network-firewall:us-east-1:700953207471:firewall/myFirewall-3",
    ResourceType: null,
    ServiceName: "AWS Network Firewall",
    TotalCost: 200,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "ap-southeast-3",
    ResourceArn: "null-4",
    ResourceId:
      "arn:aws:network-firewall:us-east-1:700953207471:firewall/myFirewall-4",
    ResourceType: null,
    ServiceName: "AWS Network Firewall",
    TotalCost: 200,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "us-east-2",
    ResourceArn: "null-5",
    ResourceId:
      "arn:aws:network-firewall:us-east-1:700953207471:firewall/myFirewall-5",
    ResourceType: null,
    ServiceName: "AWS Network Firewall",
    TotalCost: 200,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "us-east-2",
    ResourceArn: "null-6",
    ResourceId:
      "arn:aws:network-firewall:us-east-1:700953207471:firewall/myFirewall-6",
    ResourceType: null,
    ServiceName: "AWS Network Firewall",
    TotalCost: 200,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "ap-northeast-2",
    ResourceArn: "null-7",
    ResourceId:
      "arn:aws:network-firewall:us-east-1:700953207471:firewall/myFirewall-7",
    ResourceType: null,
    ServiceName: "AWS Network Firewall",
    TotalCost: 200,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
];

const neptune = [
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "ap-south-1",
    ResourceArn:
      "arn:aws:rds:us-east-1:700953207471:cluster:cluster-ixquf2p25r4qnjmkqd3lrivwhi-0",
    ResourceId:
      "arn:aws:rds:us-east-1:700953207471:cluster:cluster-ixquf2p25r4qnjmkqd3lrivwhi-0",
    ResourceType: "aws.neptune.cluster",
    ServiceName: "Amazon Neptune",
    TotalCost: 400,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "us-west-2",
    ResourceArn:
      "arn:aws:rds:us-east-1:700953207471:cluster:cluster-ixquf2p25r4qnjmkqd3lrivwhi-1",
    ResourceId:
      "arn:aws:rds:us-east-1:700953207471:cluster:cluster-ixquf2p25r4qnjmkqd3lrivwhi-1",
    ResourceType: "aws.neptune.cluster",
    ServiceName: "Amazon Neptune",
    TotalCost: 400,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "us-west-2",
    ResourceArn:
      "arn:aws:rds:us-east-1:700953207471:cluster:cluster-ixquf2p25r4qnjmkqd3lrivwhi-2",
    ResourceId:
      "arn:aws:rds:us-east-1:700953207471:cluster:cluster-ixquf2p25r4qnjmkqd3lrivwhi-2",
    ResourceType: "aws.neptune.cluster",
    ServiceName: "Amazon Neptune",
    TotalCost: 400,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "eu-west-2",
    ResourceArn:
      "arn:aws:rds:us-east-1:700953207471:cluster:cluster-ixquf2p25r4qnjmkqd3lrivwhi-3",
    ResourceId:
      "arn:aws:rds:us-east-1:700953207471:cluster:cluster-ixquf2p25r4qnjmkqd3lrivwhi-3",
    ResourceType: "aws.neptune.cluster",
    ServiceName: "Amazon Neptune",
    TotalCost: 400,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "eu-west-3",
    ResourceArn:
      "arn:aws:rds:us-east-1:700953207471:cluster:cluster-ixquf2p25r4qnjmkqd3lrivwhi-4",
    ResourceId:
      "arn:aws:rds:us-east-1:700953207471:cluster:cluster-ixquf2p25r4qnjmkqd3lrivwhi-4",
    ResourceType: "aws.neptune.cluster",
    ServiceName: "Amazon Neptune",
    TotalCost: 400,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "ca-central-1",
    ResourceArn:
      "arn:aws:rds:us-east-1:700953207471:cluster:cluster-ixquf2p25r4qnjmkqd3lrivwhi-5",
    ResourceId:
      "arn:aws:rds:us-east-1:700953207471:cluster:cluster-ixquf2p25r4qnjmkqd3lrivwhi-5",
    ResourceType: "aws.neptune.cluster",
    ServiceName: "Amazon Neptune",
    TotalCost: 400,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "us-east-2",
    ResourceArn:
      "arn:aws:rds:us-east-1:700953207471:cluster:cluster-ixquf2p25r4qnjmkqd3lrivwhi-6",
    ResourceId:
      "arn:aws:rds:us-east-1:700953207471:cluster:cluster-ixquf2p25r4qnjmkqd3lrivwhi-6",
    ResourceType: "aws.neptune.cluster",
    ServiceName: "Amazon Neptune",
    TotalCost: 400,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "eu-west-1",
    ResourceArn:
      "arn:aws:rds:us-east-1:700953207471:cluster:cluster-ixquf2p25r4qnjmkqd3lrivwhi-7",
    ResourceId:
      "arn:aws:rds:us-east-1:700953207471:cluster:cluster-ixquf2p25r4qnjmkqd3lrivwhi-7",
    ResourceType: "aws.neptune.cluster",
    ServiceName: "Amazon Neptune",
    TotalCost: 400,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
];

const rds = [
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "ap-east-1",
    ResourceArn:
      "arn:aws:rds:us-east-1:700953207471:db:wartestrds1noncompliant-700953207471-0",
    ResourceId:
      "arn:aws:rds:us-east-1:700953207471:db:wartestrds1noncompliant-700953207471-0",
    ResourceType: "aws.rds.db",
    ServiceName: "Amazon Relational Database Service",
    TotalCost: 460,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "us-east-2",
    ResourceArn:
      "arn:aws:rds:us-east-1:700953207471:db:wartestrds1noncompliant-700953207471-1",
    ResourceId:
      "arn:aws:rds:us-east-1:700953207471:db:wartestrds1noncompliant-700953207471-1",
    ResourceType: "aws.rds.db",
    ServiceName: "Amazon Relational Database Service",
    TotalCost: 460,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "eu-west-2",
    ResourceArn:
      "arn:aws:rds:us-east-1:700953207471:db:wartestrds1noncompliant-700953207471-2",
    ResourceId:
      "arn:aws:rds:us-east-1:700953207471:db:wartestrds1noncompliant-700953207471-2",
    ResourceType: "aws.rds.db",
    ServiceName: "Amazon Relational Database Service",
    TotalCost: 460,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "us-west-1",
    ResourceArn:
      "arn:aws:rds:us-east-1:700953207471:db:wartestrds1noncompliant-700953207471-3",
    ResourceId:
      "arn:aws:rds:us-east-1:700953207471:db:wartestrds1noncompliant-700953207471-3",
    ResourceType: "aws.rds.db",
    ServiceName: "Amazon Relational Database Service",
    TotalCost: 460,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "sa-east-1",
    ResourceArn:
      "arn:aws:rds:us-east-1:700953207471:db:wartestrds1noncompliant-700953207471-4",
    ResourceId:
      "arn:aws:rds:us-east-1:700953207471:db:wartestrds1noncompliant-700953207471-4",
    ResourceType: "aws.rds.db",
    ServiceName: "Amazon Relational Database Service",
    TotalCost: 460,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "ap-northeast-2",
    ResourceArn:
      "arn:aws:rds:us-east-1:700953207471:db:wartestrds1noncompliant-700953207471-5",
    ResourceId:
      "arn:aws:rds:us-east-1:700953207471:db:wartestrds1noncompliant-700953207471-5",
    ResourceType: "aws.rds.db",
    ServiceName: "Amazon Relational Database Service",
    TotalCost: 460,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "us-west-1",
    ResourceArn:
      "arn:aws:rds:us-east-1:700953207471:db:wartestrds1noncompliant-700953207471-6",
    ResourceId:
      "arn:aws:rds:us-east-1:700953207471:db:wartestrds1noncompliant-700953207471-6",
    ResourceType: "aws.rds.db",
    ServiceName: "Amazon Relational Database Service",
    TotalCost: 460,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "eu-west-3",
    ResourceArn:
      "arn:aws:rds:us-east-1:700953207471:db:wartestrds1noncompliant-700953207471-7",
    ResourceId:
      "arn:aws:rds:us-east-1:700953207471:db:wartestrds1noncompliant-700953207471-7",
    ResourceType: "aws.rds.db",
    ServiceName: "Amazon Relational Database Service",
    TotalCost: 460,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "eu-west-3",
    ResourceArn:
      "arn:aws:rds:us-east-1:700953207471:db:wartestrds1noncompliant-700953207471-8",
    ResourceId:
      "arn:aws:rds:us-east-1:700953207471:db:wartestrds1noncompliant-700953207471-8",
    ResourceType: "aws.rds.db",
    ServiceName: "Amazon Relational Database Service",
    TotalCost: 460,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "me-south-1",
    ResourceArn:
      "arn:aws:rds:us-east-1:700953207471:db:wartestrds1noncompliant-700953207471-9",
    ResourceId:
      "arn:aws:rds:us-east-1:700953207471:db:wartestrds1noncompliant-700953207471-9",
    ResourceType: "aws.rds.db",
    ServiceName: "Amazon Relational Database Service",
    TotalCost: 460,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: false,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "ap-northeast-2",
    ResourceArn:
      "arn:aws:rds:us-east-1:700953207471:db:wartestrds1noncompliant-700953207471-10",
    ResourceId:
      "arn:aws:rds:us-east-1:700953207471:db:wartestrds1noncompliant-700953207471-10",
    ResourceType: "aws.rds.db",
    ServiceName: "Amazon Relational Database Service",
    TotalCost: 460,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
];

const route53 = [
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "eu-west-1",
    ResourceArn:
      "arn:aws:r53resolver:us-east-1:700953207471:eni-064dbe4979bdad339-0",
    ResourceId:
      "arn:aws:r53resolver:us-east-1:700953207471:eni-064dbe4979bdad339-0",
    ResourceType: "aws.route53.healthcheck",
    ServiceName: "Amazon Route 53",
    TotalCost: 150,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "eu-west-2",
    ResourceArn:
      "arn:aws:r53resolver:us-east-1:700953207471:eni-064dbe4979bdad339-1",
    ResourceId:
      "arn:aws:r53resolver:us-east-1:700953207471:eni-064dbe4979bdad339-1",
    ResourceType: "aws.route53.healthcheck",
    ServiceName: "Amazon Route 53",
    TotalCost: 150,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "af-south-1",
    ResourceArn:
      "arn:aws:r53resolver:us-east-1:700953207471:eni-064dbe4979bdad339-2",
    ResourceId:
      "arn:aws:r53resolver:us-east-1:700953207471:eni-064dbe4979bdad339-2",
    ResourceType: "aws.route53.healthcheck",
    ServiceName: "Amazon Route 53",
    TotalCost: 150,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "us-west-2",
    ResourceArn:
      "arn:aws:r53resolver:us-east-1:700953207471:eni-064dbe4979bdad339-3",
    ResourceId:
      "arn:aws:r53resolver:us-east-1:700953207471:eni-064dbe4979bdad339-3",
    ResourceType: "aws.route53.healthcheck",
    ServiceName: "Amazon Route 53",
    TotalCost: 150,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "eu-south-1",
    ResourceArn:
      "arn:aws:r53resolver:us-east-1:700953207471:eni-064dbe4979bdad339-4",
    ResourceId:
      "arn:aws:r53resolver:us-east-1:700953207471:eni-064dbe4979bdad339-4",
    ResourceType: "aws.route53.healthcheck",
    ServiceName: "Amazon Route 53",
    TotalCost: 150,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: false,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "us-east-1",
    ResourceArn:
      "arn:aws:r53resolver:us-east-1:700953207471:eni-064dbe4979bdad339-5",
    ResourceId:
      "arn:aws:r53resolver:us-east-1:700953207471:eni-064dbe4979bdad339-5",
    ResourceType: "aws.route53.healthcheck",
    ServiceName: "Amazon Route 53",
    TotalCost: 150,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: false,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "eu-south-1",
    ResourceArn:
      "arn:aws:r53resolver:us-east-1:700953207471:eni-064dbe4979bdad339-6",
    ResourceId:
      "arn:aws:r53resolver:us-east-1:700953207471:eni-064dbe4979bdad339-6",
    ResourceType: "aws.route53.healthcheck",
    ServiceName: "Amazon Route 53",
    TotalCost: 150,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: false,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "sa-east-1",
    ResourceArn:
      "arn:aws:r53resolver:us-east-1:700953207471:eni-064dbe4979bdad339-7",
    ResourceId:
      "arn:aws:r53resolver:us-east-1:700953207471:eni-064dbe4979bdad339-7",
    ResourceType: "aws.route53.healthcheck",
    ServiceName: "Amazon Route 53",
    TotalCost: 150,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: false,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "ap-southeast-1",
    ResourceArn:
      "arn:aws:r53resolver:us-east-1:700953207471:eni-064dbe4979bdad339-8",
    ResourceId:
      "arn:aws:r53resolver:us-east-1:700953207471:eni-064dbe4979bdad339-8",
    ResourceType: "aws.route53.healthcheck",
    ServiceName: "Amazon Route 53",
    TotalCost: 150,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: false,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "af-south-1",
    ResourceArn:
      "arn:aws:r53resolver:us-east-1:700953207471:eni-064dbe4979bdad339-9",
    ResourceId:
      "arn:aws:r53resolver:us-east-1:700953207471:eni-064dbe4979bdad339-9",
    ResourceType: "aws.route53.healthcheck",
    ServiceName: "Amazon Route 53",
    TotalCost: 150,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: false,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "us-east-2",
    ResourceArn:
      "arn:aws:r53resolver:us-east-1:700953207471:eni-064dbe4979bdad339-10",
    ResourceId:
      "arn:aws:r53resolver:us-east-1:700953207471:eni-064dbe4979bdad339-10",
    ResourceType: "aws.route53.healthcheck",
    ServiceName: "Amazon Route 53",
    TotalCost: 150,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: false,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "ap-northeast-3",
    ResourceArn:
      "arn:aws:r53resolver:us-east-1:700953207471:eni-064dbe4979bdad339-11",
    ResourceId:
      "arn:aws:r53resolver:us-east-1:700953207471:eni-064dbe4979bdad339-11",
    ResourceType: "aws.route53.healthcheck",
    ServiceName: "Amazon Route 53",
    TotalCost: 150,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: false,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "us-east-2",
    ResourceArn:
      "arn:aws:r53resolver:us-east-1:700953207471:eni-064dbe4979bdad339-12",
    ResourceId:
      "arn:aws:r53resolver:us-east-1:700953207471:eni-064dbe4979bdad339-12",
    ResourceType: "aws.route53.healthcheck",
    ServiceName: "Amazon Route 53",
    TotalCost: 150,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: false,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "us-east-2",
    ResourceArn:
      "arn:aws:r53resolver:us-east-1:700953207471:eni-064dbe4979bdad339-13",
    ResourceId:
      "arn:aws:r53resolver:us-east-1:700953207471:eni-064dbe4979bdad339-13",
    ResourceType: "aws.route53.healthcheck",
    ServiceName: "Amazon Route 53",
    TotalCost: 150,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: false,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "ap-east-1",
    ResourceArn:
      "arn:aws:r53resolver:us-east-1:700953207471:eni-064dbe4979bdad339-14",
    ResourceId:
      "arn:aws:r53resolver:us-east-1:700953207471:eni-064dbe4979bdad339-14",
    ResourceType: "aws.route53.healthcheck",
    ServiceName: "Amazon Route 53",
    TotalCost: 150,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: false,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "ap-northeast-1",
    ResourceArn:
      "arn:aws:r53resolver:us-east-1:700953207471:eni-064dbe4979bdad339-15",
    ResourceId:
      "arn:aws:r53resolver:us-east-1:700953207471:eni-064dbe4979bdad339-15",
    ResourceType: "aws.route53.healthcheck",
    ServiceName: "Amazon Route 53",
    TotalCost: 150,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: false,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "eu-south-1",
    ResourceArn:
      "arn:aws:r53resolver:us-east-1:700953207471:eni-064dbe4979bdad339-16",
    ResourceId:
      "arn:aws:r53resolver:us-east-1:700953207471:eni-064dbe4979bdad339-16",
    ResourceType: "aws.route53.healthcheck",
    ServiceName: "Amazon Route 53",
    TotalCost: 150,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
];

const comprehend = [
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "ap-southeast-3",
    ResourceArn: "null-0",
    ResourceId: "en-0",
    ResourceType: null,
    ServiceName: "Amazon Comprehend",
    TotalCost: 200,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "us-west-2",
    ResourceArn: "null-1",
    ResourceId: "en-1",
    ResourceType: null,
    ServiceName: "Amazon Comprehend",
    TotalCost: 200,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "af-south-1",
    ResourceArn: "null-2",
    ResourceId: "en-2",
    ResourceType: null,
    ServiceName: "Amazon Comprehend",
    TotalCost: 200,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "ap-northeast-2",
    ResourceArn: "null-3",
    ResourceId: "en-3",
    ResourceType: null,
    ServiceName: "Amazon Comprehend",
    TotalCost: 200,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "us-east-2",
    ResourceArn: "null-4",
    ResourceId: "en-4",
    ResourceType: null,
    ServiceName: "Amazon Comprehend",
    TotalCost: 200,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "af-south-1",
    ResourceArn: "null-5",
    ResourceId: "en-5",
    ResourceType: null,
    ServiceName: "Amazon Comprehend",
    TotalCost: 200,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "eu-west-2",
    ResourceArn: "null-6",
    ResourceId: "en-6",
    ResourceType: null,
    ServiceName: "Amazon Comprehend",
    TotalCost: 200,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "eu-south-1",
    ResourceArn: "null-7",
    ResourceId: "en-7",
    ResourceType: null,
    ServiceName: "Amazon Comprehend",
    TotalCost: 200,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "ap-northeast-3",
    ResourceArn: "null-8",
    ResourceId: "en-8",
    ResourceType: null,
    ServiceName: "Amazon Comprehend",
    TotalCost: 200,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
];

const mapReduce = [
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "ap-northeast-1",
    ResourceArn:
      "arn:aws:elasticmapreduce:us-east-1:700953207471:cluster/j-18J0346VM1E0G-0",
    ResourceId:
      "arn:aws:elasticmapreduce:us-east-1:700953207471:cluster/j-18J0346VM1E0G-0",
    ResourceType: "aws.elasticmapreduce.cluster",
    ServiceName: "Amazon Elastic MapReduce",
    TotalCost: 860,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "eu-south-1",
    ResourceArn:
      "arn:aws:elasticmapreduce:us-east-1:700953207471:cluster/j-18J0346VM1E0G-1",
    ResourceId:
      "arn:aws:elasticmapreduce:us-east-1:700953207471:cluster/j-18J0346VM1E0G-1",
    ResourceType: "aws.elasticmapreduce.cluster",
    ServiceName: "Amazon Elastic MapReduce",
    TotalCost: 860,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "us-west-1",
    ResourceArn:
      "arn:aws:elasticmapreduce:us-east-1:700953207471:cluster/j-18J0346VM1E0G-2",
    ResourceId:
      "arn:aws:elasticmapreduce:us-east-1:700953207471:cluster/j-18J0346VM1E0G-2",
    ResourceType: "aws.elasticmapreduce.cluster",
    ServiceName: "Amazon Elastic MapReduce",
    TotalCost: 860,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "ca-central-1",
    ResourceArn:
      "arn:aws:elasticmapreduce:us-east-1:700953207471:cluster/j-18J0346VM1E0G-3",
    ResourceId:
      "arn:aws:elasticmapreduce:us-east-1:700953207471:cluster/j-18J0346VM1E0G-3",
    ResourceType: "aws.elasticmapreduce.cluster",
    ServiceName: "Amazon Elastic MapReduce",
    TotalCost: 860,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "me-south-1",
    ResourceArn:
      "arn:aws:elasticmapreduce:us-east-1:700953207471:cluster/j-18J0346VM1E0G-4",
    ResourceId:
      "arn:aws:elasticmapreduce:us-east-1:700953207471:cluster/j-18J0346VM1E0G-4",
    ResourceType: "aws.elasticmapreduce.cluster",
    ServiceName: "Amazon Elastic MapReduce",
    TotalCost: 860,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: false,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "me-south-1",
    ResourceArn:
      "arn:aws:elasticmapreduce:us-east-1:700953207471:cluster/j-18J0346VM1E0G-5",
    ResourceId:
      "arn:aws:elasticmapreduce:us-east-1:700953207471:cluster/j-18J0346VM1E0G-5",
    ResourceType: "aws.elasticmapreduce.cluster",
    ServiceName: "Amazon Elastic MapReduce",
    TotalCost: 860,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
];

const kafka = [
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "us-west-2",
    ResourceArn:
      "arn:aws:kafka:us-east-1:700953207471:cluster/map-msk-serverless-v2/d42cb6b9-70de-4beb-b2d4-61fef3e91342-s3-0",
    ResourceId:
      "arn:aws:kafka:us-east-1:700953207471:cluster/map-msk-serverless-v2/d42cb6b9-70de-4beb-b2d4-61fef3e91342-s3-0",
    ResourceType: "aws.kafka.cluster",
    ServiceName: "Amazon Managed Streaming for Apache Kafka",
    TotalCost: 1,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "eu-west-1",
    ResourceArn:
      "arn:aws:kafka:us-east-1:700953207471:cluster/map-msk-serverless-v2/d42cb6b9-70de-4beb-b2d4-61fef3e91342-s3-1",
    ResourceId:
      "arn:aws:kafka:us-east-1:700953207471:cluster/map-msk-serverless-v2/d42cb6b9-70de-4beb-b2d4-61fef3e91342-s3-1",
    ResourceType: "aws.kafka.cluster",
    ServiceName: "Amazon Managed Streaming for Apache Kafka",
    TotalCost: 1,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "eu-west-1",
    ResourceArn:
      "arn:aws:kafka:us-east-1:700953207471:cluster/map-msk-serverless-v2/d42cb6b9-70de-4beb-b2d4-61fef3e91342-s3-2",
    ResourceId:
      "arn:aws:kafka:us-east-1:700953207471:cluster/map-msk-serverless-v2/d42cb6b9-70de-4beb-b2d4-61fef3e91342-s3-2",
    ResourceType: "aws.kafka.cluster",
    ServiceName: "Amazon Managed Streaming for Apache Kafka",
    TotalCost: 1,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: false,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "eu-west-3",
    ResourceArn:
      "arn:aws:kafka:us-east-1:700953207471:cluster/map-msk-serverless-v2/d42cb6b9-70de-4beb-b2d4-61fef3e91342-s3-3",
    ResourceId:
      "arn:aws:kafka:us-east-1:700953207471:cluster/map-msk-serverless-v2/d42cb6b9-70de-4beb-b2d4-61fef3e91342-s3-3",
    ResourceType: "aws.kafka.cluster",
    ServiceName: "Amazon Managed Streaming for Apache Kafka",
    TotalCost: 1,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: false,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "ap-southeast-2",
    ResourceArn:
      "arn:aws:kafka:us-east-1:700953207471:cluster/map-msk-serverless-v2/d42cb6b9-70de-4beb-b2d4-61fef3e91342-s3-4",
    ResourceId:
      "arn:aws:kafka:us-east-1:700953207471:cluster/map-msk-serverless-v2/d42cb6b9-70de-4beb-b2d4-61fef3e91342-s3-4",
    ResourceType: "aws.kafka.cluster",
    ServiceName: "Amazon Managed Streaming for Apache Kafka",
    TotalCost: 1,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: false,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "ap-northeast-1",
    ResourceArn:
      "arn:aws:kafka:us-east-1:700953207471:cluster/map-msk-serverless-v2/d42cb6b9-70de-4beb-b2d4-61fef3e91342-s3-5",
    ResourceId:
      "arn:aws:kafka:us-east-1:700953207471:cluster/map-msk-serverless-v2/d42cb6b9-70de-4beb-b2d4-61fef3e91342-s3-5",
    ResourceType: "aws.kafka.cluster",
    ServiceName: "Amazon Managed Streaming for Apache Kafka",
    TotalCost: 1,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
];

const sageMaker = [
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "eu-west-1",
    ResourceArn:
      "arn:aws:sagemaker:us-east-1:700953207471:notebook-instance/BasicNotebookInstance-xcrp9KIkjwnZ-0",
    ResourceId:
      "arn:aws:sagemaker:us-east-1:700953207471:notebook-instance/BasicNotebookInstance-xcrp9KIkjwnZ-0",
    ResourceType: "aws.sagemaker.notebook-instance",
    ServiceName: "Amazon SageMaker",
    TotalCost: 317,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "eu-south-1",
    ResourceArn:
      "arn:aws:sagemaker:us-east-1:700953207471:notebook-instance/BasicNotebookInstance-xcrp9KIkjwnZ-1",
    ResourceId:
      "arn:aws:sagemaker:us-east-1:700953207471:notebook-instance/BasicNotebookInstance-xcrp9KIkjwnZ-1",
    ResourceType: "aws.sagemaker.notebook-instance",
    ServiceName: "Amazon SageMaker",
    TotalCost: 317,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "ap-northeast-2",
    ResourceArn:
      "arn:aws:sagemaker:us-east-1:700953207471:notebook-instance/BasicNotebookInstance-xcrp9KIkjwnZ-2",
    ResourceId:
      "arn:aws:sagemaker:us-east-1:700953207471:notebook-instance/BasicNotebookInstance-xcrp9KIkjwnZ-2",
    ResourceType: "aws.sagemaker.notebook-instance",
    ServiceName: "Amazon SageMaker",
    TotalCost: 317,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "eu-central-1",
    ResourceArn:
      "arn:aws:sagemaker:us-east-1:700953207471:notebook-instance/BasicNotebookInstance-xcrp9KIkjwnZ-3",
    ResourceId:
      "arn:aws:sagemaker:us-east-1:700953207471:notebook-instance/BasicNotebookInstance-xcrp9KIkjwnZ-3",
    ResourceType: "aws.sagemaker.notebook-instance",
    ServiceName: "Amazon SageMaker",
    TotalCost: 317,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "eu-west-1",
    ResourceArn:
      "arn:aws:sagemaker:us-east-1:700953207471:notebook-instance/BasicNotebookInstance-xcrp9KIkjwnZ-4",
    ResourceId:
      "arn:aws:sagemaker:us-east-1:700953207471:notebook-instance/BasicNotebookInstance-xcrp9KIkjwnZ-4",
    ResourceType: "aws.sagemaker.notebook-instance",
    ServiceName: "Amazon SageMaker",
    TotalCost: 317,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "us-west-1",
    ResourceArn:
      "arn:aws:sagemaker:us-east-1:700953207471:notebook-instance/BasicNotebookInstance-xcrp9KIkjwnZ-5",
    ResourceId:
      "arn:aws:sagemaker:us-east-1:700953207471:notebook-instance/BasicNotebookInstance-xcrp9KIkjwnZ-5",
    ResourceType: "aws.sagemaker.notebook-instance",
    ServiceName: "Amazon SageMaker",
    TotalCost: 317,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: false,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "sa-east-1",
    ResourceArn:
      "arn:aws:sagemaker:us-east-1:700953207471:notebook-instance/BasicNotebookInstance-xcrp9KIkjwnZ-6",
    ResourceId:
      "arn:aws:sagemaker:us-east-1:700953207471:notebook-instance/BasicNotebookInstance-xcrp9KIkjwnZ-6",
    ResourceType: "aws.sagemaker.notebook-instance",
    ServiceName: "Amazon SageMaker",
    TotalCost: 317,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: false,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "us-west-2",
    ResourceArn:
      "arn:aws:sagemaker:us-east-1:700953207471:notebook-instance/BasicNotebookInstance-xcrp9KIkjwnZ-7",
    ResourceId:
      "arn:aws:sagemaker:us-east-1:700953207471:notebook-instance/BasicNotebookInstance-xcrp9KIkjwnZ-7",
    ResourceType: "aws.sagemaker.notebook-instance",
    ServiceName: "Amazon SageMaker",
    TotalCost: 317,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
];

const dms = [
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "ap-northeast-2",
    ResourceArn: "null-0",
    ResourceId:
      "arn:aws:dms:us-east-1:700953207471:rep:G4CATYASOAQM5KA7CCFTDHTID5GV2UFN6DRZRJQ-0",
    ResourceType: null,
    ServiceName: "AWS Database Migration Service",
    TotalCost: 300,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "sa-east-1",
    ResourceArn: "null-1",
    ResourceId:
      "arn:aws:dms:us-east-1:700953207471:rep:G4CATYASOAQM5KA7CCFTDHTID5GV2UFN6DRZRJQ-1",
    ResourceType: null,
    ServiceName: "AWS Database Migration Service",
    TotalCost: 300,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "us-east-2",
    ResourceArn: "null-2",
    ResourceId:
      "arn:aws:dms:us-east-1:700953207471:rep:G4CATYASOAQM5KA7CCFTDHTID5GV2UFN6DRZRJQ-2",
    ResourceType: null,
    ServiceName: "AWS Database Migration Service",
    TotalCost: 300,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
];

const openSearch = [
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "eu-west-2",
    ResourceArn:
      "arn:aws:es:us-east-1:700953207471:domain/map-opensearch-domain-0",
    ResourceId:
      "arn:aws:es:us-east-1:700953207471:domain/map-opensearch-domain-0",
    ResourceType: "aws.es.domain",
    ServiceName: "Amazon OpenSearch Service",
    TotalCost: 525,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "ap-east-1",
    ResourceArn:
      "arn:aws:es:us-east-1:700953207471:domain/map-opensearch-domain-1",
    ResourceId:
      "arn:aws:es:us-east-1:700953207471:domain/map-opensearch-domain-1",
    ResourceType: "aws.es.domain",
    ServiceName: "Amazon OpenSearch Service",
    TotalCost: 525,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "us-west-1",
    ResourceArn:
      "arn:aws:es:us-east-1:700953207471:domain/map-opensearch-domain-2",
    ResourceId:
      "arn:aws:es:us-east-1:700953207471:domain/map-opensearch-domain-2",
    ResourceType: "aws.es.domain",
    ServiceName: "Amazon OpenSearch Service",
    TotalCost: 525,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "ca-central-1",
    ResourceArn:
      "arn:aws:es:us-east-1:700953207471:domain/map-opensearch-domain-3",
    ResourceId:
      "arn:aws:es:us-east-1:700953207471:domain/map-opensearch-domain-3",
    ResourceType: "aws.es.domain",
    ServiceName: "Amazon OpenSearch Service",
    TotalCost: 525,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: false,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "us-west-1",
    ResourceArn:
      "arn:aws:es:us-east-1:700953207471:domain/map-opensearch-domain-4",
    ResourceId:
      "arn:aws:es:us-east-1:700953207471:domain/map-opensearch-domain-4",
    ResourceType: "aws.es.domain",
    ServiceName: "Amazon OpenSearch Service",
    TotalCost: 525,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: false,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "eu-south-1",
    ResourceArn:
      "arn:aws:es:us-east-1:700953207471:domain/map-opensearch-domain-5",
    ResourceId:
      "arn:aws:es:us-east-1:700953207471:domain/map-opensearch-domain-5",
    ResourceType: "aws.es.domain",
    ServiceName: "Amazon OpenSearch Service",
    TotalCost: 525,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: false,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "eu-central-1",
    ResourceArn:
      "arn:aws:es:us-east-1:700953207471:domain/map-opensearch-domain-6",
    ResourceId:
      "arn:aws:es:us-east-1:700953207471:domain/map-opensearch-domain-6",
    ResourceType: "aws.es.domain",
    ServiceName: "Amazon OpenSearch Service",
    TotalCost: 525,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
];

const systemsManager = [
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "us-east-1",
    ResourceArn: "null-0",
    ResourceId: "0668406c-169e-416b-ab54-e3a40f556ec2-0",
    ResourceType: null,
    ServiceName: "AWS Systems Manager",
    TotalCost: 80,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "ap-northeast-3",
    ResourceArn: "null-1",
    ResourceId: "0668406c-169e-416b-ab54-e3a40f556ec2-1",
    ResourceType: null,
    ServiceName: "AWS Systems Manager",
    TotalCost: 80,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "us-west-2",
    ResourceArn: "null-2",
    ResourceId: "0668406c-169e-416b-ab54-e3a40f556ec2-2",
    ResourceType: null,
    ServiceName: "AWS Systems Manager",
    TotalCost: 80,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "us-west-2",
    ResourceArn: "null-3",
    ResourceId: "0668406c-169e-416b-ab54-e3a40f556ec2-3",
    ResourceType: null,
    ServiceName: "AWS Systems Manager",
    TotalCost: 80,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "eu-west-2",
    ResourceArn: "null-4",
    ResourceId: "0668406c-169e-416b-ab54-e3a40f556ec2-4",
    ResourceType: null,
    ServiceName: "AWS Systems Manager",
    TotalCost: 80,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: false,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "sa-east-1",
    ResourceArn: "null-5",
    ResourceId: "0668406c-169e-416b-ab54-e3a40f556ec2-5",
    ResourceType: null,
    ServiceName: "AWS Systems Manager",
    TotalCost: 80,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: false,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "ap-east-1",
    ResourceArn: "null-6",
    ResourceId: "0668406c-169e-416b-ab54-e3a40f556ec2-6",
    ResourceType: null,
    ServiceName: "AWS Systems Manager",
    TotalCost: 80,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: false,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "eu-west-2",
    ResourceArn: "null-7",
    ResourceId: "0668406c-169e-416b-ab54-e3a40f556ec2-7",
    ResourceType: null,
    ServiceName: "AWS Systems Manager",
    TotalCost: 80,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: false,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "us-west-2",
    ResourceArn: "null-8",
    ResourceId: "0668406c-169e-416b-ab54-e3a40f556ec2-8",
    ResourceType: null,
    ServiceName: "AWS Systems Manager",
    TotalCost: 80,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: false,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "us-east-1",
    ResourceArn: "null-9",
    ResourceId: "0668406c-169e-416b-ab54-e3a40f556ec2-9",
    ResourceType: null,
    ServiceName: "AWS Systems Manager",
    TotalCost: 80,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: false,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "eu-west-3",
    ResourceArn: "null-10",
    ResourceId: "0668406c-169e-416b-ab54-e3a40f556ec2-10",
    ResourceType: null,
    ServiceName: "AWS Systems Manager",
    TotalCost: 80,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: false,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "me-south-1",
    ResourceArn: "null-11",
    ResourceId: "0668406c-169e-416b-ab54-e3a40f556ec2-11",
    ResourceType: null,
    ServiceName: "AWS Systems Manager",
    TotalCost: 80,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: false,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "sa-east-1",
    ResourceArn: "null-12",
    ResourceId: "0668406c-169e-416b-ab54-e3a40f556ec2-12",
    ResourceType: null,
    ServiceName: "AWS Systems Manager",
    TotalCost: 80,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: false,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "us-east-2",
    ResourceArn: "null-13",
    ResourceId: "0668406c-169e-416b-ab54-e3a40f556ec2-13",
    ResourceType: null,
    ServiceName: "AWS Systems Manager",
    TotalCost: 80,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: false,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "eu-south-1",
    ResourceArn: "null-14",
    ResourceId: "0668406c-169e-416b-ab54-e3a40f556ec2-14",
    ResourceType: null,
    ServiceName: "AWS Systems Manager",
    TotalCost: 80,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
];

const secretsManager = [
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "eu-west-2",
    ResourceArn:
      "arn:aws:secretsmanager:us-east-1:700953207471:secret:MontyCloudGlueConnectionCredentials-4AMJpb-0",
    ResourceId:
      "arn:aws:secretsmanager:us-east-1:700953207471:secret:MontyCloudGlueConnectionCredentials-4AMJpb-0",
    ResourceType: "aws.secretsmanager.secret",
    ServiceName: "AWS Secrets Manager",
    TotalCost: 52.5,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "af-south-1",
    ResourceArn:
      "arn:aws:secretsmanager:us-east-1:700953207471:secret:MontyCloudGlueConnectionCredentials-4AMJpb-1",
    ResourceId:
      "arn:aws:secretsmanager:us-east-1:700953207471:secret:MontyCloudGlueConnectionCredentials-4AMJpb-1",
    ResourceType: "aws.secretsmanager.secret",
    ServiceName: "AWS Secrets Manager",
    TotalCost: 52.5,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "ap-east-1",
    ResourceArn:
      "arn:aws:secretsmanager:us-east-1:700953207471:secret:MontyCloudGlueConnectionCredentials-4AMJpb-2",
    ResourceId:
      "arn:aws:secretsmanager:us-east-1:700953207471:secret:MontyCloudGlueConnectionCredentials-4AMJpb-2",
    ResourceType: "aws.secretsmanager.secret",
    ServiceName: "AWS Secrets Manager",
    TotalCost: 52.5,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "us-east-2",
    ResourceArn:
      "arn:aws:secretsmanager:us-east-1:700953207471:secret:MontyCloudGlueConnectionCredentials-4AMJpb-3",
    ResourceId:
      "arn:aws:secretsmanager:us-east-1:700953207471:secret:MontyCloudGlueConnectionCredentials-4AMJpb-3",
    ResourceType: "aws.secretsmanager.secret",
    ServiceName: "AWS Secrets Manager",
    TotalCost: 52.5,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "ap-southeast-2",
    ResourceArn:
      "arn:aws:secretsmanager:us-east-1:700953207471:secret:MontyCloudGlueConnectionCredentials-4AMJpb-4",
    ResourceId:
      "arn:aws:secretsmanager:us-east-1:700953207471:secret:MontyCloudGlueConnectionCredentials-4AMJpb-4",
    ResourceType: "aws.secretsmanager.secret",
    ServiceName: "AWS Secrets Manager",
    TotalCost: 52.5,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "ap-northeast-3",
    ResourceArn:
      "arn:aws:secretsmanager:us-east-1:700953207471:secret:MontyCloudGlueConnectionCredentials-4AMJpb-5",
    ResourceId:
      "arn:aws:secretsmanager:us-east-1:700953207471:secret:MontyCloudGlueConnectionCredentials-4AMJpb-5",
    ResourceType: "aws.secretsmanager.secret",
    ServiceName: "AWS Secrets Manager",
    TotalCost: 52.5,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "eu-west-1",
    ResourceArn:
      "arn:aws:secretsmanager:us-east-1:700953207471:secret:MontyCloudGlueConnectionCredentials-4AMJpb-6",
    ResourceId:
      "arn:aws:secretsmanager:us-east-1:700953207471:secret:MontyCloudGlueConnectionCredentials-4AMJpb-6",
    ResourceType: "aws.secretsmanager.secret",
    ServiceName: "AWS Secrets Manager",
    TotalCost: 52.5,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "eu-south-1",
    ResourceArn:
      "arn:aws:secretsmanager:us-east-1:700953207471:secret:MontyCloudGlueConnectionCredentials-4AMJpb-7",
    ResourceId:
      "arn:aws:secretsmanager:us-east-1:700953207471:secret:MontyCloudGlueConnectionCredentials-4AMJpb-7",
    ResourceType: "aws.secretsmanager.secret",
    ServiceName: "AWS Secrets Manager",
    TotalCost: 52.5,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: false,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "ap-southeast-1",
    ResourceArn:
      "arn:aws:secretsmanager:us-east-1:700953207471:secret:MontyCloudGlueConnectionCredentials-4AMJpb-8",
    ResourceId:
      "arn:aws:secretsmanager:us-east-1:700953207471:secret:MontyCloudGlueConnectionCredentials-4AMJpb-8",
    ResourceType: "aws.secretsmanager.secret",
    ServiceName: "AWS Secrets Manager",
    TotalCost: 52.5,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: false,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "eu-north-1",
    ResourceArn:
      "arn:aws:secretsmanager:us-east-1:700953207471:secret:MontyCloudGlueConnectionCredentials-4AMJpb-9",
    ResourceId:
      "arn:aws:secretsmanager:us-east-1:700953207471:secret:MontyCloudGlueConnectionCredentials-4AMJpb-9",
    ResourceType: "aws.secretsmanager.secret",
    ServiceName: "AWS Secrets Manager",
    TotalCost: 52.5,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: false,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "eu-west-1",
    ResourceArn:
      "arn:aws:secretsmanager:us-east-1:700953207471:secret:MontyCloudGlueConnectionCredentials-4AMJpb-10",
    ResourceId:
      "arn:aws:secretsmanager:us-east-1:700953207471:secret:MontyCloudGlueConnectionCredentials-4AMJpb-10",
    ResourceType: "aws.secretsmanager.secret",
    ServiceName: "AWS Secrets Manager",
    TotalCost: 52.5,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: false,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "ap-northeast-3",
    ResourceArn:
      "arn:aws:secretsmanager:us-east-1:700953207471:secret:MontyCloudGlueConnectionCredentials-4AMJpb-11",
    ResourceId:
      "arn:aws:secretsmanager:us-east-1:700953207471:secret:MontyCloudGlueConnectionCredentials-4AMJpb-11",
    ResourceType: "aws.secretsmanager.secret",
    ServiceName: "AWS Secrets Manager",
    TotalCost: 52.5,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: false,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "us-east-1",
    ResourceArn:
      "arn:aws:secretsmanager:us-east-1:700953207471:secret:MontyCloudGlueConnectionCredentials-4AMJpb-12",
    ResourceId:
      "arn:aws:secretsmanager:us-east-1:700953207471:secret:MontyCloudGlueConnectionCredentials-4AMJpb-12",
    ResourceType: "aws.secretsmanager.secret",
    ServiceName: "AWS Secrets Manager",
    TotalCost: 52.5,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: false,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "eu-west-2",
    ResourceArn:
      "arn:aws:secretsmanager:us-east-1:700953207471:secret:MontyCloudGlueConnectionCredentials-4AMJpb-13",
    ResourceId:
      "arn:aws:secretsmanager:us-east-1:700953207471:secret:MontyCloudGlueConnectionCredentials-4AMJpb-13",
    ResourceType: "aws.secretsmanager.secret",
    ServiceName: "AWS Secrets Manager",
    TotalCost: 52.5,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: false,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "me-south-1",
    ResourceArn:
      "arn:aws:secretsmanager:us-east-1:700953207471:secret:MontyCloudGlueConnectionCredentials-4AMJpb-14",
    ResourceId:
      "arn:aws:secretsmanager:us-east-1:700953207471:secret:MontyCloudGlueConnectionCredentials-4AMJpb-14",
    ResourceType: "aws.secretsmanager.secret",
    ServiceName: "AWS Secrets Manager",
    TotalCost: 52.5,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: false,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "me-south-1",
    ResourceArn:
      "arn:aws:secretsmanager:us-east-1:700953207471:secret:MontyCloudGlueConnectionCredentials-4AMJpb-15",
    ResourceId:
      "arn:aws:secretsmanager:us-east-1:700953207471:secret:MontyCloudGlueConnectionCredentials-4AMJpb-15",
    ResourceType: "aws.secretsmanager.secret",
    ServiceName: "AWS Secrets Manager",
    TotalCost: 52.5,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: false,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "ap-southeast-1",
    ResourceArn:
      "arn:aws:secretsmanager:us-east-1:700953207471:secret:MontyCloudGlueConnectionCredentials-4AMJpb-16",
    ResourceId:
      "arn:aws:secretsmanager:us-east-1:700953207471:secret:MontyCloudGlueConnectionCredentials-4AMJpb-16",
    ResourceType: "aws.secretsmanager.secret",
    ServiceName: "AWS Secrets Manager",
    TotalCost: 52.5,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: false,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "ap-southeast-2",
    ResourceArn:
      "arn:aws:secretsmanager:us-east-1:700953207471:secret:MontyCloudGlueConnectionCredentials-4AMJpb-17",
    ResourceId:
      "arn:aws:secretsmanager:us-east-1:700953207471:secret:MontyCloudGlueConnectionCredentials-4AMJpb-17",
    ResourceType: "aws.secretsmanager.secret",
    ServiceName: "AWS Secrets Manager",
    TotalCost: 52.5,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: false,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "us-west-1",
    ResourceArn:
      "arn:aws:secretsmanager:us-east-1:700953207471:secret:MontyCloudGlueConnectionCredentials-4AMJpb-18",
    ResourceId:
      "arn:aws:secretsmanager:us-east-1:700953207471:secret:MontyCloudGlueConnectionCredentials-4AMJpb-18",
    ResourceType: "aws.secretsmanager.secret",
    ServiceName: "AWS Secrets Manager",
    TotalCost: 52.5,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: false,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "eu-north-1",
    ResourceArn:
      "arn:aws:secretsmanager:us-east-1:700953207471:secret:MontyCloudGlueConnectionCredentials-4AMJpb-19",
    ResourceId:
      "arn:aws:secretsmanager:us-east-1:700953207471:secret:MontyCloudGlueConnectionCredentials-4AMJpb-19",
    ResourceType: "aws.secretsmanager.secret",
    ServiceName: "AWS Secrets Manager",
    TotalCost: 52.5,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
];

const appStream = [
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "eu-west-3",
    ResourceArn:
      "arn:aws:appstream:us-east-1:700953207471:image-builder/MyImageBuilder-0",
    ResourceId:
      "arn:aws:appstream:us-east-1:700953207471:image-builder/MyImageBuilder-0",
    ResourceType: "aws.appstream.image-builder",
    ServiceName: "Amazon AppStream",
    TotalCost: 280,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "ap-south-1",
    ResourceArn:
      "arn:aws:appstream:us-east-1:700953207471:image-builder/MyImageBuilder-1",
    ResourceId:
      "arn:aws:appstream:us-east-1:700953207471:image-builder/MyImageBuilder-1",
    ResourceType: "aws.appstream.image-builder",
    ServiceName: "Amazon AppStream",
    TotalCost: 280,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "ap-northeast-3",
    ResourceArn:
      "arn:aws:appstream:us-east-1:700953207471:image-builder/MyImageBuilder-2",
    ResourceId:
      "arn:aws:appstream:us-east-1:700953207471:image-builder/MyImageBuilder-2",
    ResourceType: "aws.appstream.image-builder",
    ServiceName: "Amazon AppStream",
    TotalCost: 280,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "me-south-1",
    ResourceArn:
      "arn:aws:appstream:us-east-1:700953207471:image-builder/MyImageBuilder-3",
    ResourceId:
      "arn:aws:appstream:us-east-1:700953207471:image-builder/MyImageBuilder-3",
    ResourceType: "aws.appstream.image-builder",
    ServiceName: "Amazon AppStream",
    TotalCost: 280,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "us-west-2",
    ResourceArn:
      "arn:aws:appstream:us-east-1:700953207471:image-builder/MyImageBuilder-4",
    ResourceId:
      "arn:aws:appstream:us-east-1:700953207471:image-builder/MyImageBuilder-4",
    ResourceType: "aws.appstream.image-builder",
    ServiceName: "Amazon AppStream",
    TotalCost: 280,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: false,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "eu-west-3",
    ResourceArn:
      "arn:aws:appstream:us-east-1:700953207471:image-builder/MyImageBuilder-5",
    ResourceId:
      "arn:aws:appstream:us-east-1:700953207471:image-builder/MyImageBuilder-5",
    ResourceType: "aws.appstream.image-builder",
    ServiceName: "Amazon AppStream",
    TotalCost: 280,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: false,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "ap-south-1",
    ResourceArn:
      "arn:aws:appstream:us-east-1:700953207471:image-builder/MyImageBuilder-6",
    ResourceId:
      "arn:aws:appstream:us-east-1:700953207471:image-builder/MyImageBuilder-6",
    ResourceType: "aws.appstream.image-builder",
    ServiceName: "Amazon AppStream",
    TotalCost: 280,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: false,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "eu-west-3",
    ResourceArn:
      "arn:aws:appstream:us-east-1:700953207471:image-builder/MyImageBuilder-7",
    ResourceId:
      "arn:aws:appstream:us-east-1:700953207471:image-builder/MyImageBuilder-7",
    ResourceType: "aws.appstream.image-builder",
    ServiceName: "Amazon AppStream",
    TotalCost: 280,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
];

const kms = [
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "eu-west-3",
    ResourceArn:
      "arn:aws:kms:ap-south-1:700953207471:key/b76d3f43-10d4-452b-9bfe-cb541a0d6763-0",
    ResourceId:
      "arn:aws:kms:ap-south-1:700953207471:key/b76d3f43-10d4-452b-9bfe-cb541a0d6763-0",
    ResourceType: "aws.kms.key",
    ServiceName: "AWS Key Management Service",
    TotalCost: 33.33,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "ap-east-1",
    ResourceArn:
      "arn:aws:kms:ap-south-1:700953207471:key/b76d3f43-10d4-452b-9bfe-cb541a0d6763-1",
    ResourceId:
      "arn:aws:kms:ap-south-1:700953207471:key/b76d3f43-10d4-452b-9bfe-cb541a0d6763-1",
    ResourceType: "aws.kms.key",
    ServiceName: "AWS Key Management Service",
    TotalCost: 33.33,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "ap-east-1",
    ResourceArn:
      "arn:aws:kms:ap-south-1:700953207471:key/b76d3f43-10d4-452b-9bfe-cb541a0d6763-2",
    ResourceId:
      "arn:aws:kms:ap-south-1:700953207471:key/b76d3f43-10d4-452b-9bfe-cb541a0d6763-2",
    ResourceType: "aws.kms.key",
    ServiceName: "AWS Key Management Service",
    TotalCost: 33.33,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "eu-west-2",
    ResourceArn:
      "arn:aws:kms:ap-south-1:700953207471:key/b76d3f43-10d4-452b-9bfe-cb541a0d6763-3",
    ResourceId:
      "arn:aws:kms:ap-south-1:700953207471:key/b76d3f43-10d4-452b-9bfe-cb541a0d6763-3",
    ResourceType: "aws.kms.key",
    ServiceName: "AWS Key Management Service",
    TotalCost: 33.33,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "us-east-1",
    ResourceArn:
      "arn:aws:kms:ap-south-1:700953207471:key/b76d3f43-10d4-452b-9bfe-cb541a0d6763-4",
    ResourceId:
      "arn:aws:kms:ap-south-1:700953207471:key/b76d3f43-10d4-452b-9bfe-cb541a0d6763-4",
    ResourceType: "aws.kms.key",
    ServiceName: "AWS Key Management Service",
    TotalCost: 33.33,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "ap-southeast-3",
    ResourceArn:
      "arn:aws:kms:ap-south-1:700953207471:key/b76d3f43-10d4-452b-9bfe-cb541a0d6763-5",
    ResourceId:
      "arn:aws:kms:ap-south-1:700953207471:key/b76d3f43-10d4-452b-9bfe-cb541a0d6763-5",
    ResourceType: "aws.kms.key",
    ServiceName: "AWS Key Management Service",
    TotalCost: 33.33,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "ap-northeast-1",
    ResourceArn:
      "arn:aws:kms:ap-south-1:700953207471:key/b76d3f43-10d4-452b-9bfe-cb541a0d6763-6",
    ResourceId:
      "arn:aws:kms:ap-south-1:700953207471:key/b76d3f43-10d4-452b-9bfe-cb541a0d6763-6",
    ResourceType: "aws.kms.key",
    ServiceName: "AWS Key Management Service",
    TotalCost: 33.33,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "sa-east-1",
    ResourceArn:
      "arn:aws:kms:ap-south-1:700953207471:key/b76d3f43-10d4-452b-9bfe-cb541a0d6763-7",
    ResourceId:
      "arn:aws:kms:ap-south-1:700953207471:key/b76d3f43-10d4-452b-9bfe-cb541a0d6763-7",
    ResourceType: "aws.kms.key",
    ServiceName: "AWS Key Management Service",
    TotalCost: 33.33,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "eu-west-2",
    ResourceArn:
      "arn:aws:kms:ap-south-1:700953207471:key/b76d3f43-10d4-452b-9bfe-cb541a0d6763-8",
    ResourceId:
      "arn:aws:kms:ap-south-1:700953207471:key/b76d3f43-10d4-452b-9bfe-cb541a0d6763-8",
    ResourceType: "aws.kms.key",
    ServiceName: "AWS Key Management Service",
    TotalCost: 33.33,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "us-east-2",
    ResourceArn:
      "arn:aws:kms:ap-south-1:700953207471:key/b76d3f43-10d4-452b-9bfe-cb541a0d6763-9",
    ResourceId:
      "arn:aws:kms:ap-south-1:700953207471:key/b76d3f43-10d4-452b-9bfe-cb541a0d6763-9",
    ResourceType: "aws.kms.key",
    ServiceName: "AWS Key Management Service",
    TotalCost: 33.33,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "ap-northeast-3",
    ResourceArn:
      "arn:aws:kms:ap-south-1:700953207471:key/b76d3f43-10d4-452b-9bfe-cb541a0d6763-10",
    ResourceId:
      "arn:aws:kms:ap-south-1:700953207471:key/b76d3f43-10d4-452b-9bfe-cb541a0d6763-10",
    ResourceType: "aws.kms.key",
    ServiceName: "AWS Key Management Service",
    TotalCost: 33.33,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "eu-west-3",
    ResourceArn:
      "arn:aws:kms:ap-south-1:700953207471:key/b76d3f43-10d4-452b-9bfe-cb541a0d6763-11",
    ResourceId:
      "arn:aws:kms:ap-south-1:700953207471:key/b76d3f43-10d4-452b-9bfe-cb541a0d6763-11",
    ResourceType: "aws.kms.key",
    ServiceName: "AWS Key Management Service",
    TotalCost: 33.33,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: false,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "eu-west-3",
    ResourceArn:
      "arn:aws:kms:ap-south-1:700953207471:key/b76d3f43-10d4-452b-9bfe-cb541a0d6763-12",
    ResourceId:
      "arn:aws:kms:ap-south-1:700953207471:key/b76d3f43-10d4-452b-9bfe-cb541a0d6763-12",
    ResourceType: "aws.kms.key",
    ServiceName: "AWS Key Management Service",
    TotalCost: 33.33,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: false,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "us-west-1",
    ResourceArn:
      "arn:aws:kms:ap-south-1:700953207471:key/b76d3f43-10d4-452b-9bfe-cb541a0d6763-13",
    ResourceId:
      "arn:aws:kms:ap-south-1:700953207471:key/b76d3f43-10d4-452b-9bfe-cb541a0d6763-13",
    ResourceType: "aws.kms.key",
    ServiceName: "AWS Key Management Service",
    TotalCost: 33.33,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: false,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "eu-south-1",
    ResourceArn:
      "arn:aws:kms:ap-south-1:700953207471:key/b76d3f43-10d4-452b-9bfe-cb541a0d6763-14",
    ResourceId:
      "arn:aws:kms:ap-south-1:700953207471:key/b76d3f43-10d4-452b-9bfe-cb541a0d6763-14",
    ResourceType: "aws.kms.key",
    ServiceName: "AWS Key Management Service",
    TotalCost: 33.33,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: false,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "ca-central-1",
    ResourceArn:
      "arn:aws:kms:ap-south-1:700953207471:key/b76d3f43-10d4-452b-9bfe-cb541a0d6763-15",
    ResourceId:
      "arn:aws:kms:ap-south-1:700953207471:key/b76d3f43-10d4-452b-9bfe-cb541a0d6763-15",
    ResourceType: "aws.kms.key",
    ServiceName: "AWS Key Management Service",
    TotalCost: 33.33,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: false,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "me-south-1",
    ResourceArn:
      "arn:aws:kms:ap-south-1:700953207471:key/b76d3f43-10d4-452b-9bfe-cb541a0d6763-16",
    ResourceId:
      "arn:aws:kms:ap-south-1:700953207471:key/b76d3f43-10d4-452b-9bfe-cb541a0d6763-16",
    ResourceType: "aws.kms.key",
    ServiceName: "AWS Key Management Service",
    TotalCost: 33.33,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: false,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "ap-northeast-2",
    ResourceArn:
      "arn:aws:kms:ap-south-1:700953207471:key/b76d3f43-10d4-452b-9bfe-cb541a0d6763-17",
    ResourceId:
      "arn:aws:kms:ap-south-1:700953207471:key/b76d3f43-10d4-452b-9bfe-cb541a0d6763-17",
    ResourceType: "aws.kms.key",
    ServiceName: "AWS Key Management Service",
    TotalCost: 33.33,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: false,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "ap-northeast-1",
    ResourceArn:
      "arn:aws:kms:ap-south-1:700953207471:key/b76d3f43-10d4-452b-9bfe-cb541a0d6763-18",
    ResourceId:
      "arn:aws:kms:ap-south-1:700953207471:key/b76d3f43-10d4-452b-9bfe-cb541a0d6763-18",
    ResourceType: "aws.kms.key",
    ServiceName: "AWS Key Management Service",
    TotalCost: 33.33,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: false,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "sa-east-1",
    ResourceArn:
      "arn:aws:kms:ap-south-1:700953207471:key/b76d3f43-10d4-452b-9bfe-cb541a0d6763-19",
    ResourceId:
      "arn:aws:kms:ap-south-1:700953207471:key/b76d3f43-10d4-452b-9bfe-cb541a0d6763-19",
    ResourceType: "aws.kms.key",
    ServiceName: "AWS Key Management Service",
    TotalCost: 33.33,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: false,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "us-west-1",
    ResourceArn:
      "arn:aws:kms:ap-south-1:700953207471:key/b76d3f43-10d4-452b-9bfe-cb541a0d6763-20",
    ResourceId:
      "arn:aws:kms:ap-south-1:700953207471:key/b76d3f43-10d4-452b-9bfe-cb541a0d6763-20",
    ResourceType: "aws.kms.key",
    ServiceName: "AWS Key Management Service",
    TotalCost: 33.33,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: false,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "ap-southeast-3",
    ResourceArn:
      "arn:aws:kms:ap-south-1:700953207471:key/b76d3f43-10d4-452b-9bfe-cb541a0d6763-21",
    ResourceId:
      "arn:aws:kms:ap-south-1:700953207471:key/b76d3f43-10d4-452b-9bfe-cb541a0d6763-21",
    ResourceType: "aws.kms.key",
    ServiceName: "AWS Key Management Service",
    TotalCost: 33.33,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: false,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "us-west-1",
    ResourceArn:
      "arn:aws:kms:ap-south-1:700953207471:key/b76d3f43-10d4-452b-9bfe-cb541a0d6763-22",
    ResourceId:
      "arn:aws:kms:ap-south-1:700953207471:key/b76d3f43-10d4-452b-9bfe-cb541a0d6763-22",
    ResourceType: "aws.kms.key",
    ServiceName: "AWS Key Management Service",
    TotalCost: 33.33,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: false,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "us-east-1",
    ResourceArn:
      "arn:aws:kms:ap-south-1:700953207471:key/b76d3f43-10d4-452b-9bfe-cb541a0d6763-23",
    ResourceId:
      "arn:aws:kms:ap-south-1:700953207471:key/b76d3f43-10d4-452b-9bfe-cb541a0d6763-23",
    ResourceType: "aws.kms.key",
    ServiceName: "AWS Key Management Service",
    TotalCost: 33.33,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: false,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "af-south-1",
    ResourceArn:
      "arn:aws:kms:ap-south-1:700953207471:key/b76d3f43-10d4-452b-9bfe-cb541a0d6763-24",
    ResourceId:
      "arn:aws:kms:ap-south-1:700953207471:key/b76d3f43-10d4-452b-9bfe-cb541a0d6763-24",
    ResourceType: "aws.kms.key",
    ServiceName: "AWS Key Management Service",
    TotalCost: 33.33,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: false,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "eu-central-1",
    ResourceArn:
      "arn:aws:kms:ap-south-1:700953207471:key/b76d3f43-10d4-452b-9bfe-cb541a0d6763-25",
    ResourceId:
      "arn:aws:kms:ap-south-1:700953207471:key/b76d3f43-10d4-452b-9bfe-cb541a0d6763-25",
    ResourceType: "aws.kms.key",
    ServiceName: "AWS Key Management Service",
    TotalCost: 33.33,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: false,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "us-east-2",
    ResourceArn:
      "arn:aws:kms:ap-south-1:700953207471:key/b76d3f43-10d4-452b-9bfe-cb541a0d6763-26",
    ResourceId:
      "arn:aws:kms:ap-south-1:700953207471:key/b76d3f43-10d4-452b-9bfe-cb541a0d6763-26",
    ResourceType: "aws.kms.key",
    ServiceName: "AWS Key Management Service",
    TotalCost: 33.33,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: false,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "eu-west-3",
    ResourceArn:
      "arn:aws:kms:ap-south-1:700953207471:key/b76d3f43-10d4-452b-9bfe-cb541a0d6763-27",
    ResourceId:
      "arn:aws:kms:ap-south-1:700953207471:key/b76d3f43-10d4-452b-9bfe-cb541a0d6763-27",
    ResourceType: "aws.kms.key",
    ServiceName: "AWS Key Management Service",
    TotalCost: 33.33,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: false,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "sa-east-1",
    ResourceArn:
      "arn:aws:kms:ap-south-1:700953207471:key/b76d3f43-10d4-452b-9bfe-cb541a0d6763-28",
    ResourceId:
      "arn:aws:kms:ap-south-1:700953207471:key/b76d3f43-10d4-452b-9bfe-cb541a0d6763-28",
    ResourceType: "aws.kms.key",
    ServiceName: "AWS Key Management Service",
    TotalCost: 33.33,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: false,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "eu-west-2",
    ResourceArn:
      "arn:aws:kms:ap-south-1:700953207471:key/b76d3f43-10d4-452b-9bfe-cb541a0d6763-29",
    ResourceId:
      "arn:aws:kms:ap-south-1:700953207471:key/b76d3f43-10d4-452b-9bfe-cb541a0d6763-29",
    ResourceType: "aws.kms.key",
    ServiceName: "AWS Key Management Service",
    TotalCost: 33.33,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: false,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "us-west-2",
    ResourceArn:
      "arn:aws:kms:ap-south-1:700953207471:key/b76d3f43-10d4-452b-9bfe-cb541a0d6763-30",
    ResourceId:
      "arn:aws:kms:ap-south-1:700953207471:key/b76d3f43-10d4-452b-9bfe-cb541a0d6763-30",
    ResourceType: "aws.kms.key",
    ServiceName: "AWS Key Management Service",
    TotalCost: 33.33,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: false,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "ap-northeast-2",
    ResourceArn:
      "arn:aws:kms:ap-south-1:700953207471:key/b76d3f43-10d4-452b-9bfe-cb541a0d6763-31",
    ResourceId:
      "arn:aws:kms:ap-south-1:700953207471:key/b76d3f43-10d4-452b-9bfe-cb541a0d6763-31",
    ResourceType: "aws.kms.key",
    ServiceName: "AWS Key Management Service",
    TotalCost: 33.33,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
];

const apiGateway = [
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "eu-west-1",
    ResourceArn:
      "arn:aws:apigateway:us-east-1::/restapis/dejz8x6y5l/stages/unencrpytcache-0",
    ResourceId:
      "arn:aws:apigateway:us-east-1::/restapis/dejz8x6y5l/stages/unencrpytcache-0",
    ResourceType: "aws.apigateway.restapis",
    ServiceName: "Amazon API Gateway",
    TotalCost: 175,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "ap-southeast-1",
    ResourceArn:
      "arn:aws:apigateway:us-east-1::/restapis/dejz8x6y5l/stages/unencrpytcache-1",
    ResourceId:
      "arn:aws:apigateway:us-east-1::/restapis/dejz8x6y5l/stages/unencrpytcache-1",
    ResourceType: "aws.apigateway.restapis",
    ServiceName: "Amazon API Gateway",
    TotalCost: 175,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "eu-central-1",
    ResourceArn:
      "arn:aws:apigateway:us-east-1::/restapis/dejz8x6y5l/stages/unencrpytcache-2",
    ResourceId:
      "arn:aws:apigateway:us-east-1::/restapis/dejz8x6y5l/stages/unencrpytcache-2",
    ResourceType: "aws.apigateway.restapis",
    ServiceName: "Amazon API Gateway",
    TotalCost: 175,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "eu-west-1",
    ResourceArn:
      "arn:aws:apigateway:us-east-1::/restapis/dejz8x6y5l/stages/unencrpytcache-3",
    ResourceId:
      "arn:aws:apigateway:us-east-1::/restapis/dejz8x6y5l/stages/unencrpytcache-3",
    ResourceType: "aws.apigateway.restapis",
    ServiceName: "Amazon API Gateway",
    TotalCost: 175,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "us-west-2",
    ResourceArn:
      "arn:aws:apigateway:us-east-1::/restapis/dejz8x6y5l/stages/unencrpytcache-4",
    ResourceId:
      "arn:aws:apigateway:us-east-1::/restapis/dejz8x6y5l/stages/unencrpytcache-4",
    ResourceType: "aws.apigateway.restapis",
    ServiceName: "Amazon API Gateway",
    TotalCost: 175,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "us-west-2",
    ResourceArn:
      "arn:aws:apigateway:us-east-1::/restapis/dejz8x6y5l/stages/unencrpytcache-5",
    ResourceId:
      "arn:aws:apigateway:us-east-1::/restapis/dejz8x6y5l/stages/unencrpytcache-5",
    ResourceType: "aws.apigateway.restapis",
    ServiceName: "Amazon API Gateway",
    TotalCost: 175,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "ca-central-1",
    ResourceArn:
      "arn:aws:apigateway:us-east-1::/restapis/dejz8x6y5l/stages/unencrpytcache-6",
    ResourceId:
      "arn:aws:apigateway:us-east-1::/restapis/dejz8x6y5l/stages/unencrpytcache-6",
    ResourceType: "aws.apigateway.restapis",
    ServiceName: "Amazon API Gateway",
    TotalCost: 175,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "ap-east-1",
    ResourceArn:
      "arn:aws:apigateway:us-east-1::/restapis/dejz8x6y5l/stages/unencrpytcache-7",
    ResourceId:
      "arn:aws:apigateway:us-east-1::/restapis/dejz8x6y5l/stages/unencrpytcache-7",
    ResourceType: "aws.apigateway.restapis",
    ServiceName: "Amazon API Gateway",
    TotalCost: 175,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
];

const lambda = [
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "eu-central-1",
    ResourceArn:
      "arn:aws:lambda:us-east-1:700953207471:function:aws-controltower-NotificationForwarder-0",
    ResourceId:
      "arn:aws:lambda:us-east-1:700953207471:function:aws-controltower-NotificationForwarder-0",
    ResourceType: "aws.lambda.function",
    ServiceName: "AWS Lambda",
    TotalCost: 159.09,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "ap-southeast-3",
    ResourceArn:
      "arn:aws:lambda:us-east-1:700953207471:function:aws-controltower-NotificationForwarder-1",
    ResourceId:
      "arn:aws:lambda:us-east-1:700953207471:function:aws-controltower-NotificationForwarder-1",
    ResourceType: "aws.lambda.function",
    ServiceName: "AWS Lambda",
    TotalCost: 159.09,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "eu-north-1",
    ResourceArn:
      "arn:aws:lambda:us-east-1:700953207471:function:aws-controltower-NotificationForwarder-2",
    ResourceId:
      "arn:aws:lambda:us-east-1:700953207471:function:aws-controltower-NotificationForwarder-2",
    ResourceType: "aws.lambda.function",
    ServiceName: "AWS Lambda",
    TotalCost: 159.09,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "eu-central-1",
    ResourceArn:
      "arn:aws:lambda:us-east-1:700953207471:function:aws-controltower-NotificationForwarder-3",
    ResourceId:
      "arn:aws:lambda:us-east-1:700953207471:function:aws-controltower-NotificationForwarder-3",
    ResourceType: "aws.lambda.function",
    ServiceName: "AWS Lambda",
    TotalCost: 159.09,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "us-east-2",
    ResourceArn:
      "arn:aws:lambda:us-east-1:700953207471:function:aws-controltower-NotificationForwarder-4",
    ResourceId:
      "arn:aws:lambda:us-east-1:700953207471:function:aws-controltower-NotificationForwarder-4",
    ResourceType: "aws.lambda.function",
    ServiceName: "AWS Lambda",
    TotalCost: 159.09,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "ap-southeast-3",
    ResourceArn:
      "arn:aws:lambda:us-east-1:700953207471:function:aws-controltower-NotificationForwarder-5",
    ResourceId:
      "arn:aws:lambda:us-east-1:700953207471:function:aws-controltower-NotificationForwarder-5",
    ResourceType: "aws.lambda.function",
    ServiceName: "AWS Lambda",
    TotalCost: 159.09,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "us-west-2",
    ResourceArn:
      "arn:aws:lambda:us-east-1:700953207471:function:aws-controltower-NotificationForwarder-6",
    ResourceId:
      "arn:aws:lambda:us-east-1:700953207471:function:aws-controltower-NotificationForwarder-6",
    ResourceType: "aws.lambda.function",
    ServiceName: "AWS Lambda",
    TotalCost: 159.09,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "ap-south-1",
    ResourceArn:
      "arn:aws:lambda:us-east-1:700953207471:function:aws-controltower-NotificationForwarder-7",
    ResourceId:
      "arn:aws:lambda:us-east-1:700953207471:function:aws-controltower-NotificationForwarder-7",
    ResourceType: "aws.lambda.function",
    ServiceName: "AWS Lambda",
    TotalCost: 159.09,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "sa-east-1",
    ResourceArn:
      "arn:aws:lambda:us-east-1:700953207471:function:aws-controltower-NotificationForwarder-8",
    ResourceId:
      "arn:aws:lambda:us-east-1:700953207471:function:aws-controltower-NotificationForwarder-8",
    ResourceType: "aws.lambda.function",
    ServiceName: "AWS Lambda",
    TotalCost: 159.09,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "eu-west-3",
    ResourceArn:
      "arn:aws:lambda:us-east-1:700953207471:function:aws-controltower-NotificationForwarder-9",
    ResourceId:
      "arn:aws:lambda:us-east-1:700953207471:function:aws-controltower-NotificationForwarder-9",
    ResourceType: "aws.lambda.function",
    ServiceName: "AWS Lambda",
    TotalCost: 159.09,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "eu-west-3",
    ResourceArn:
      "arn:aws:lambda:us-east-1:700953207471:function:aws-controltower-NotificationForwarder-10",
    ResourceId:
      "arn:aws:lambda:us-east-1:700953207471:function:aws-controltower-NotificationForwarder-10",
    ResourceType: "aws.lambda.function",
    ServiceName: "AWS Lambda",
    TotalCost: 159.09,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "ap-east-1",
    ResourceArn:
      "arn:aws:lambda:us-east-1:700953207471:function:aws-controltower-NotificationForwarder-11",
    ResourceId:
      "arn:aws:lambda:us-east-1:700953207471:function:aws-controltower-NotificationForwarder-11",
    ResourceType: "aws.lambda.function",
    ServiceName: "AWS Lambda",
    TotalCost: 159.09,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "ap-southeast-2",
    ResourceArn:
      "arn:aws:lambda:us-east-1:700953207471:function:aws-controltower-NotificationForwarder-12",
    ResourceId:
      "arn:aws:lambda:us-east-1:700953207471:function:aws-controltower-NotificationForwarder-12",
    ResourceType: "aws.lambda.function",
    ServiceName: "AWS Lambda",
    TotalCost: 159.09,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "eu-north-1",
    ResourceArn:
      "arn:aws:lambda:us-east-1:700953207471:function:aws-controltower-NotificationForwarder-13",
    ResourceId:
      "arn:aws:lambda:us-east-1:700953207471:function:aws-controltower-NotificationForwarder-13",
    ResourceType: "aws.lambda.function",
    ServiceName: "AWS Lambda",
    TotalCost: 159.09,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "us-west-2",
    ResourceArn:
      "arn:aws:lambda:us-east-1:700953207471:function:aws-controltower-NotificationForwarder-14",
    ResourceId:
      "arn:aws:lambda:us-east-1:700953207471:function:aws-controltower-NotificationForwarder-14",
    ResourceType: "aws.lambda.function",
    ServiceName: "AWS Lambda",
    TotalCost: 159.09,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "eu-central-1",
    ResourceArn:
      "arn:aws:lambda:us-east-1:700953207471:function:aws-controltower-NotificationForwarder-15",
    ResourceId:
      "arn:aws:lambda:us-east-1:700953207471:function:aws-controltower-NotificationForwarder-15",
    ResourceType: "aws.lambda.function",
    ServiceName: "AWS Lambda",
    TotalCost: 159.09,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "ap-northeast-3",
    ResourceArn:
      "arn:aws:lambda:us-east-1:700953207471:function:aws-controltower-NotificationForwarder-16",
    ResourceId:
      "arn:aws:lambda:us-east-1:700953207471:function:aws-controltower-NotificationForwarder-16",
    ResourceType: "aws.lambda.function",
    ServiceName: "AWS Lambda",
    TotalCost: 159.09,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "af-south-1",
    ResourceArn:
      "arn:aws:lambda:us-east-1:700953207471:function:aws-controltower-NotificationForwarder-17",
    ResourceId:
      "arn:aws:lambda:us-east-1:700953207471:function:aws-controltower-NotificationForwarder-17",
    ResourceType: "aws.lambda.function",
    ServiceName: "AWS Lambda",
    TotalCost: 159.09,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "ap-south-1",
    ResourceArn:
      "arn:aws:lambda:us-east-1:700953207471:function:aws-controltower-NotificationForwarder-18",
    ResourceId:
      "arn:aws:lambda:us-east-1:700953207471:function:aws-controltower-NotificationForwarder-18",
    ResourceType: "aws.lambda.function",
    ServiceName: "AWS Lambda",
    TotalCost: 159.09,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "eu-north-1",
    ResourceArn:
      "arn:aws:lambda:us-east-1:700953207471:function:aws-controltower-NotificationForwarder-19",
    ResourceId:
      "arn:aws:lambda:us-east-1:700953207471:function:aws-controltower-NotificationForwarder-19",
    ResourceType: "aws.lambda.function",
    ServiceName: "AWS Lambda",
    TotalCost: 159.09,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "eu-south-1",
    ResourceArn:
      "arn:aws:lambda:us-east-1:700953207471:function:aws-controltower-NotificationForwarder-20",
    ResourceId:
      "arn:aws:lambda:us-east-1:700953207471:function:aws-controltower-NotificationForwarder-20",
    ResourceType: "aws.lambda.function",
    ServiceName: "AWS Lambda",
    TotalCost: 159.09,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "ap-northeast-2",
    ResourceArn:
      "arn:aws:lambda:us-east-1:700953207471:function:aws-controltower-NotificationForwarder-21",
    ResourceId:
      "arn:aws:lambda:us-east-1:700953207471:function:aws-controltower-NotificationForwarder-21",
    ResourceType: "aws.lambda.function",
    ServiceName: "AWS Lambda",
    TotalCost: 159.09,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: false,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "ap-southeast-3",
    ResourceArn:
      "arn:aws:lambda:us-east-1:700953207471:function:aws-controltower-NotificationForwarder-22",
    ResourceId:
      "arn:aws:lambda:us-east-1:700953207471:function:aws-controltower-NotificationForwarder-22",
    ResourceType: "aws.lambda.function",
    ServiceName: "AWS Lambda",
    TotalCost: 159.09,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: false,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "ca-central-1",
    ResourceArn:
      "arn:aws:lambda:us-east-1:700953207471:function:aws-controltower-NotificationForwarder-23",
    ResourceId:
      "arn:aws:lambda:us-east-1:700953207471:function:aws-controltower-NotificationForwarder-23",
    ResourceType: "aws.lambda.function",
    ServiceName: "AWS Lambda",
    TotalCost: 159.09,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: false,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "ap-northeast-3",
    ResourceArn:
      "arn:aws:lambda:us-east-1:700953207471:function:aws-controltower-NotificationForwarder-24",
    ResourceId:
      "arn:aws:lambda:us-east-1:700953207471:function:aws-controltower-NotificationForwarder-24",
    ResourceType: "aws.lambda.function",
    ServiceName: "AWS Lambda",
    TotalCost: 159.09,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: false,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "ap-south-1",
    ResourceArn:
      "arn:aws:lambda:us-east-1:700953207471:function:aws-controltower-NotificationForwarder-25",
    ResourceId:
      "arn:aws:lambda:us-east-1:700953207471:function:aws-controltower-NotificationForwarder-25",
    ResourceType: "aws.lambda.function",
    ServiceName: "AWS Lambda",
    TotalCost: 159.09,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: false,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "ap-southeast-1",
    ResourceArn:
      "arn:aws:lambda:us-east-1:700953207471:function:aws-controltower-NotificationForwarder-26",
    ResourceId:
      "arn:aws:lambda:us-east-1:700953207471:function:aws-controltower-NotificationForwarder-26",
    ResourceType: "aws.lambda.function",
    ServiceName: "AWS Lambda",
    TotalCost: 159.09,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: false,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "ap-east-1",
    ResourceArn:
      "arn:aws:lambda:us-east-1:700953207471:function:aws-controltower-NotificationForwarder-27",
    ResourceId:
      "arn:aws:lambda:us-east-1:700953207471:function:aws-controltower-NotificationForwarder-27",
    ResourceType: "aws.lambda.function",
    ServiceName: "AWS Lambda",
    TotalCost: 159.09,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: false,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "us-east-2",
    ResourceArn:
      "arn:aws:lambda:us-east-1:700953207471:function:aws-controltower-NotificationForwarder-28",
    ResourceId:
      "arn:aws:lambda:us-east-1:700953207471:function:aws-controltower-NotificationForwarder-28",
    ResourceType: "aws.lambda.function",
    ServiceName: "AWS Lambda",
    TotalCost: 159.09,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: false,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "ca-central-1",
    ResourceArn:
      "arn:aws:lambda:us-east-1:700953207471:function:aws-controltower-NotificationForwarder-29",
    ResourceId:
      "arn:aws:lambda:us-east-1:700953207471:function:aws-controltower-NotificationForwarder-29",
    ResourceType: "aws.lambda.function",
    ServiceName: "AWS Lambda",
    TotalCost: 159.09,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: false,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "eu-west-2",
    ResourceArn:
      "arn:aws:lambda:us-east-1:700953207471:function:aws-controltower-NotificationForwarder-30",
    ResourceId:
      "arn:aws:lambda:us-east-1:700953207471:function:aws-controltower-NotificationForwarder-30",
    ResourceType: "aws.lambda.function",
    ServiceName: "AWS Lambda",
    TotalCost: 159.09,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: false,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "us-west-1",
    ResourceArn:
      "arn:aws:lambda:us-east-1:700953207471:function:aws-controltower-NotificationForwarder-31",
    ResourceId:
      "arn:aws:lambda:us-east-1:700953207471:function:aws-controltower-NotificationForwarder-31",
    ResourceType: "aws.lambda.function",
    ServiceName: "AWS Lambda",
    TotalCost: 159.09,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: false,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "ap-east-1",
    ResourceArn:
      "arn:aws:lambda:us-east-1:700953207471:function:aws-controltower-NotificationForwarder-32",
    ResourceId:
      "arn:aws:lambda:us-east-1:700953207471:function:aws-controltower-NotificationForwarder-32",
    ResourceType: "aws.lambda.function",
    ServiceName: "AWS Lambda",
    TotalCost: 159.09,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: false,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "us-east-2",
    ResourceArn:
      "arn:aws:lambda:us-east-1:700953207471:function:aws-controltower-NotificationForwarder-33",
    ResourceId:
      "arn:aws:lambda:us-east-1:700953207471:function:aws-controltower-NotificationForwarder-33",
    ResourceType: "aws.lambda.function",
    ServiceName: "AWS Lambda",
    TotalCost: 159.09,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: false,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "af-south-1",
    ResourceArn:
      "arn:aws:lambda:us-east-1:700953207471:function:aws-controltower-NotificationForwarder-34",
    ResourceId:
      "arn:aws:lambda:us-east-1:700953207471:function:aws-controltower-NotificationForwarder-34",
    ResourceType: "aws.lambda.function",
    ServiceName: "AWS Lambda",
    TotalCost: 159.09,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: false,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "eu-west-3",
    ResourceArn:
      "arn:aws:lambda:us-east-1:700953207471:function:aws-controltower-NotificationForwarder-35",
    ResourceId:
      "arn:aws:lambda:us-east-1:700953207471:function:aws-controltower-NotificationForwarder-35",
    ResourceType: "aws.lambda.function",
    ServiceName: "AWS Lambda",
    TotalCost: 159.09,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: false,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "ap-northeast-2",
    ResourceArn:
      "arn:aws:lambda:us-east-1:700953207471:function:aws-controltower-NotificationForwarder-36",
    ResourceId:
      "arn:aws:lambda:us-east-1:700953207471:function:aws-controltower-NotificationForwarder-36",
    ResourceType: "aws.lambda.function",
    ServiceName: "AWS Lambda",
    TotalCost: 159.09,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
];

const efs = [
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "af-south-1",
    ResourceArn:
      "arn:aws:elasticfilesystem:us-east-1:700953207471:file-system/fs-021a16cc4d73f9933-0",
    ResourceId:
      "arn:aws:elasticfilesystem:us-east-1:700953207471:file-system/fs-021a16cc4d73f9933-0",
    ResourceType: "aws.elasticfilesystem.file-system",
    ServiceName: "Amazon Elastic File System",
    TotalCost: 180,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "eu-west-3",
    ResourceArn:
      "arn:aws:elasticfilesystem:us-east-1:700953207471:file-system/fs-021a16cc4d73f9933-1",
    ResourceId:
      "arn:aws:elasticfilesystem:us-east-1:700953207471:file-system/fs-021a16cc4d73f9933-1",
    ResourceType: "aws.elasticfilesystem.file-system",
    ServiceName: "Amazon Elastic File System",
    TotalCost: 180,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "eu-north-1",
    ResourceArn:
      "arn:aws:elasticfilesystem:us-east-1:700953207471:file-system/fs-021a16cc4d73f9933-2",
    ResourceId:
      "arn:aws:elasticfilesystem:us-east-1:700953207471:file-system/fs-021a16cc4d73f9933-2",
    ResourceType: "aws.elasticfilesystem.file-system",
    ServiceName: "Amazon Elastic File System",
    TotalCost: 180,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "ap-south-1",
    ResourceArn:
      "arn:aws:elasticfilesystem:us-east-1:700953207471:file-system/fs-021a16cc4d73f9933-3",
    ResourceId:
      "arn:aws:elasticfilesystem:us-east-1:700953207471:file-system/fs-021a16cc4d73f9933-3",
    ResourceType: "aws.elasticfilesystem.file-system",
    ServiceName: "Amazon Elastic File System",
    TotalCost: 180,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "us-east-1",
    ResourceArn:
      "arn:aws:elasticfilesystem:us-east-1:700953207471:file-system/fs-021a16cc4d73f9933-4",
    ResourceId:
      "arn:aws:elasticfilesystem:us-east-1:700953207471:file-system/fs-021a16cc4d73f9933-4",
    ResourceType: "aws.elasticfilesystem.file-system",
    ServiceName: "Amazon Elastic File System",
    TotalCost: 180,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "me-south-1",
    ResourceArn:
      "arn:aws:elasticfilesystem:us-east-1:700953207471:file-system/fs-021a16cc4d73f9933-5",
    ResourceId:
      "arn:aws:elasticfilesystem:us-east-1:700953207471:file-system/fs-021a16cc4d73f9933-5",
    ResourceType: "aws.elasticfilesystem.file-system",
    ServiceName: "Amazon Elastic File System",
    TotalCost: 180,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "eu-south-1",
    ResourceArn:
      "arn:aws:elasticfilesystem:us-east-1:700953207471:file-system/fs-021a16cc4d73f9933-6",
    ResourceId:
      "arn:aws:elasticfilesystem:us-east-1:700953207471:file-system/fs-021a16cc4d73f9933-6",
    ResourceType: "aws.elasticfilesystem.file-system",
    ServiceName: "Amazon Elastic File System",
    TotalCost: 180,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "ap-east-1",
    ResourceArn:
      "arn:aws:elasticfilesystem:us-east-1:700953207471:file-system/fs-021a16cc4d73f9933-7",
    ResourceId:
      "arn:aws:elasticfilesystem:us-east-1:700953207471:file-system/fs-021a16cc4d73f9933-7",
    ResourceType: "aws.elasticfilesystem.file-system",
    ServiceName: "Amazon Elastic File System",
    TotalCost: 180,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "ap-southeast-2",
    ResourceArn:
      "arn:aws:elasticfilesystem:us-east-1:700953207471:file-system/fs-021a16cc4d73f9933-8",
    ResourceId:
      "arn:aws:elasticfilesystem:us-east-1:700953207471:file-system/fs-021a16cc4d73f9933-8",
    ResourceType: "aws.elasticfilesystem.file-system",
    ServiceName: "Amazon Elastic File System",
    TotalCost: 180,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "eu-west-1",
    ResourceArn:
      "arn:aws:elasticfilesystem:us-east-1:700953207471:file-system/fs-021a16cc4d73f9933-9",
    ResourceId:
      "arn:aws:elasticfilesystem:us-east-1:700953207471:file-system/fs-021a16cc4d73f9933-9",
    ResourceType: "aws.elasticfilesystem.file-system",
    ServiceName: "Amazon Elastic File System",
    TotalCost: 180,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: false,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "ap-southeast-3",
    ResourceArn:
      "arn:aws:elasticfilesystem:us-east-1:700953207471:file-system/fs-021a16cc4d73f9933-10",
    ResourceId:
      "arn:aws:elasticfilesystem:us-east-1:700953207471:file-system/fs-021a16cc4d73f9933-10",
    ResourceType: "aws.elasticfilesystem.file-system",
    ServiceName: "Amazon Elastic File System",
    TotalCost: 180,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: false,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "ap-northeast-2",
    ResourceArn:
      "arn:aws:elasticfilesystem:us-east-1:700953207471:file-system/fs-021a16cc4d73f9933-11",
    ResourceId:
      "arn:aws:elasticfilesystem:us-east-1:700953207471:file-system/fs-021a16cc4d73f9933-11",
    ResourceType: "aws.elasticfilesystem.file-system",
    ServiceName: "Amazon Elastic File System",
    TotalCost: 180,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
];

const kinesis = [
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "eu-west-3",
    ResourceArn:
      "arn:aws:kinesis:us-east-1:700953207471:stream/my-kinesis-stream-0",
    ResourceId:
      "arn:aws:kinesis:us-east-1:700953207471:stream/my-kinesis-stream-0",
    ResourceType: "aws.kinesis.stream",
    ServiceName: "Amazon Kinesis",
    TotalCost: 300,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "ap-southeast-3",
    ResourceArn:
      "arn:aws:kinesis:us-east-1:700953207471:stream/my-kinesis-stream-1",
    ResourceId:
      "arn:aws:kinesis:us-east-1:700953207471:stream/my-kinesis-stream-1",
    ResourceType: "aws.kinesis.stream",
    ServiceName: "Amazon Kinesis",
    TotalCost: 300,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "ap-northeast-3",
    ResourceArn:
      "arn:aws:kinesis:us-east-1:700953207471:stream/my-kinesis-stream-2",
    ResourceId:
      "arn:aws:kinesis:us-east-1:700953207471:stream/my-kinesis-stream-2",
    ResourceType: "aws.kinesis.stream",
    ServiceName: "Amazon Kinesis",
    TotalCost: 300,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: false,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "ap-south-1",
    ResourceArn:
      "arn:aws:kinesis:us-east-1:700953207471:stream/my-kinesis-stream-3",
    ResourceId:
      "arn:aws:kinesis:us-east-1:700953207471:stream/my-kinesis-stream-3",
    ResourceType: "aws.kinesis.stream",
    ServiceName: "Amazon Kinesis",
    TotalCost: 300,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: false,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "ap-southeast-1",
    ResourceArn:
      "arn:aws:kinesis:us-east-1:700953207471:stream/my-kinesis-stream-4",
    ResourceId:
      "arn:aws:kinesis:us-east-1:700953207471:stream/my-kinesis-stream-4",
    ResourceType: "aws.kinesis.stream",
    ServiceName: "Amazon Kinesis",
    TotalCost: 300,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: false,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "ap-southeast-3",
    ResourceArn:
      "arn:aws:kinesis:us-east-1:700953207471:stream/my-kinesis-stream-5",
    ResourceId:
      "arn:aws:kinesis:us-east-1:700953207471:stream/my-kinesis-stream-5",
    ResourceType: "aws.kinesis.stream",
    ServiceName: "Amazon Kinesis",
    TotalCost: 300,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: false,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "me-south-1",
    ResourceArn:
      "arn:aws:kinesis:us-east-1:700953207471:stream/my-kinesis-stream-6",
    ResourceId:
      "arn:aws:kinesis:us-east-1:700953207471:stream/my-kinesis-stream-6",
    ResourceType: "aws.kinesis.stream",
    ServiceName: "Amazon Kinesis",
    TotalCost: 300,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
];

const ec2 = [
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "eu-west-1",
    ResourceArn:
      "arn:aws:ec2:us-east-1:700953207471:natgateway/nat-08aa89c9129079120-0",
    ResourceId:
      "arn:aws:ec2:us-east-1:700953207471:natgateway/nat-08aa89c9129079120-0",
    ResourceType: "aws.ec2.natgateway",
    ServiceName: "Amazon Elastic Compute Cloud",
    TotalCost: 212,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "ap-southeast-2",
    ResourceArn:
      "arn:aws:ec2:us-east-1:700953207471:natgateway/nat-08aa89c9129079120-1",
    ResourceId:
      "arn:aws:ec2:us-east-1:700953207471:natgateway/nat-08aa89c9129079120-1",
    ResourceType: "aws.ec2.natgateway",
    ServiceName: "Amazon Elastic Compute Cloud",
    TotalCost: 212,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "eu-west-3",
    ResourceArn:
      "arn:aws:ec2:us-east-1:700953207471:natgateway/nat-08aa89c9129079120-2",
    ResourceId:
      "arn:aws:ec2:us-east-1:700953207471:natgateway/nat-08aa89c9129079120-2",
    ResourceType: "aws.ec2.natgateway",
    ServiceName: "Amazon Elastic Compute Cloud",
    TotalCost: 212,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "us-west-1",
    ResourceArn:
      "arn:aws:ec2:us-east-1:700953207471:natgateway/nat-08aa89c9129079120-3",
    ResourceId:
      "arn:aws:ec2:us-east-1:700953207471:natgateway/nat-08aa89c9129079120-3",
    ResourceType: "aws.ec2.natgateway",
    ServiceName: "Amazon Elastic Compute Cloud",
    TotalCost: 212,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "us-west-1",
    ResourceArn:
      "arn:aws:ec2:us-east-1:700953207471:natgateway/nat-08aa89c9129079120-4",
    ResourceId:
      "arn:aws:ec2:us-east-1:700953207471:natgateway/nat-08aa89c9129079120-4",
    ResourceType: "aws.ec2.natgateway",
    ServiceName: "Amazon Elastic Compute Cloud",
    TotalCost: 212,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "ap-southeast-2",
    ResourceArn:
      "arn:aws:ec2:us-east-1:700953207471:natgateway/nat-08aa89c9129079120-5",
    ResourceId:
      "arn:aws:ec2:us-east-1:700953207471:natgateway/nat-08aa89c9129079120-5",
    ResourceType: "aws.ec2.natgateway",
    ServiceName: "Amazon Elastic Compute Cloud",
    TotalCost: 212,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "ap-northeast-1",
    ResourceArn:
      "arn:aws:ec2:us-east-1:700953207471:natgateway/nat-08aa89c9129079120-6",
    ResourceId:
      "arn:aws:ec2:us-east-1:700953207471:natgateway/nat-08aa89c9129079120-6",
    ResourceType: "aws.ec2.natgateway",
    ServiceName: "Amazon Elastic Compute Cloud",
    TotalCost: 212,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "ca-central-1",
    ResourceArn:
      "arn:aws:ec2:us-east-1:700953207471:natgateway/nat-08aa89c9129079120-7",
    ResourceId:
      "arn:aws:ec2:us-east-1:700953207471:natgateway/nat-08aa89c9129079120-7",
    ResourceType: "aws.ec2.natgateway",
    ServiceName: "Amazon Elastic Compute Cloud",
    TotalCost: 212,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "us-east-2",
    ResourceArn:
      "arn:aws:ec2:us-east-1:700953207471:natgateway/nat-08aa89c9129079120-8",
    ResourceId:
      "arn:aws:ec2:us-east-1:700953207471:natgateway/nat-08aa89c9129079120-8",
    ResourceType: "aws.ec2.natgateway",
    ServiceName: "Amazon Elastic Compute Cloud",
    TotalCost: 212,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "us-east-1",
    ResourceArn:
      "arn:aws:ec2:us-east-1:700953207471:natgateway/nat-08aa89c9129079120-9",
    ResourceId:
      "arn:aws:ec2:us-east-1:700953207471:natgateway/nat-08aa89c9129079120-9",
    ResourceType: "aws.ec2.natgateway",
    ServiceName: "Amazon Elastic Compute Cloud",
    TotalCost: 212,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "ap-east-1",
    ResourceArn:
      "arn:aws:ec2:us-east-1:700953207471:natgateway/nat-08aa89c9129079120-10",
    ResourceId:
      "arn:aws:ec2:us-east-1:700953207471:natgateway/nat-08aa89c9129079120-10",
    ResourceType: "aws.ec2.natgateway",
    ServiceName: "Amazon Elastic Compute Cloud",
    TotalCost: 212,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "sa-east-1",
    ResourceArn:
      "arn:aws:ec2:us-east-1:700953207471:natgateway/nat-08aa89c9129079120-11",
    ResourceId:
      "arn:aws:ec2:us-east-1:700953207471:natgateway/nat-08aa89c9129079120-11",
    ResourceType: "aws.ec2.natgateway",
    ServiceName: "Amazon Elastic Compute Cloud",
    TotalCost: 212,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "eu-central-1",
    ResourceArn:
      "arn:aws:ec2:us-east-1:700953207471:natgateway/nat-08aa89c9129079120-12",
    ResourceId:
      "arn:aws:ec2:us-east-1:700953207471:natgateway/nat-08aa89c9129079120-12",
    ResourceType: "aws.ec2.natgateway",
    ServiceName: "Amazon Elastic Compute Cloud",
    TotalCost: 212,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "us-west-2",
    ResourceArn:
      "arn:aws:ec2:us-east-1:700953207471:natgateway/nat-08aa89c9129079120-13",
    ResourceId:
      "arn:aws:ec2:us-east-1:700953207471:natgateway/nat-08aa89c9129079120-13",
    ResourceType: "aws.ec2.natgateway",
    ServiceName: "Amazon Elastic Compute Cloud",
    TotalCost: 212,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "ap-east-1",
    ResourceArn:
      "arn:aws:ec2:us-east-1:700953207471:natgateway/nat-08aa89c9129079120-14",
    ResourceId:
      "arn:aws:ec2:us-east-1:700953207471:natgateway/nat-08aa89c9129079120-14",
    ResourceType: "aws.ec2.natgateway",
    ServiceName: "Amazon Elastic Compute Cloud",
    TotalCost: 212,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "eu-west-1",
    ResourceArn:
      "arn:aws:ec2:us-east-1:700953207471:natgateway/nat-08aa89c9129079120-15",
    ResourceId:
      "arn:aws:ec2:us-east-1:700953207471:natgateway/nat-08aa89c9129079120-15",
    ResourceType: "aws.ec2.natgateway",
    ServiceName: "Amazon Elastic Compute Cloud",
    TotalCost: 212,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "ap-east-1",
    ResourceArn:
      "arn:aws:ec2:us-east-1:700953207471:natgateway/nat-08aa89c9129079120-16",
    ResourceId:
      "arn:aws:ec2:us-east-1:700953207471:natgateway/nat-08aa89c9129079120-16",
    ResourceType: "aws.ec2.natgateway",
    ServiceName: "Amazon Elastic Compute Cloud",
    TotalCost: 212,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "us-east-1",
    ResourceArn:
      "arn:aws:ec2:us-east-1:700953207471:natgateway/nat-08aa89c9129079120-17",
    ResourceId:
      "arn:aws:ec2:us-east-1:700953207471:natgateway/nat-08aa89c9129079120-17",
    ResourceType: "aws.ec2.natgateway",
    ServiceName: "Amazon Elastic Compute Cloud",
    TotalCost: 212,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "eu-west-2",
    ResourceArn:
      "arn:aws:ec2:us-east-1:700953207471:natgateway/nat-08aa89c9129079120-18",
    ResourceId:
      "arn:aws:ec2:us-east-1:700953207471:natgateway/nat-08aa89c9129079120-18",
    ResourceType: "aws.ec2.natgateway",
    ServiceName: "Amazon Elastic Compute Cloud",
    TotalCost: 212,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "eu-central-1",
    ResourceArn:
      "arn:aws:ec2:us-east-1:700953207471:natgateway/nat-08aa89c9129079120-19",
    ResourceId:
      "arn:aws:ec2:us-east-1:700953207471:natgateway/nat-08aa89c9129079120-19",
    ResourceType: "aws.ec2.natgateway",
    ServiceName: "Amazon Elastic Compute Cloud",
    TotalCost: 212,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "eu-west-1",
    ResourceArn:
      "arn:aws:ec2:us-east-1:700953207471:natgateway/nat-08aa89c9129079120-20",
    ResourceId:
      "arn:aws:ec2:us-east-1:700953207471:natgateway/nat-08aa89c9129079120-20",
    ResourceType: "aws.ec2.natgateway",
    ServiceName: "Amazon Elastic Compute Cloud",
    TotalCost: 212,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "ca-central-1",
    ResourceArn:
      "arn:aws:ec2:us-east-1:700953207471:natgateway/nat-08aa89c9129079120-21",
    ResourceId:
      "arn:aws:ec2:us-east-1:700953207471:natgateway/nat-08aa89c9129079120-21",
    ResourceType: "aws.ec2.natgateway",
    ServiceName: "Amazon Elastic Compute Cloud",
    TotalCost: 212,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "af-south-1",
    ResourceArn:
      "arn:aws:ec2:us-east-1:700953207471:natgateway/nat-08aa89c9129079120-22",
    ResourceId:
      "arn:aws:ec2:us-east-1:700953207471:natgateway/nat-08aa89c9129079120-22",
    ResourceType: "aws.ec2.natgateway",
    ServiceName: "Amazon Elastic Compute Cloud",
    TotalCost: 212,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "eu-west-3",
    ResourceArn:
      "arn:aws:ec2:us-east-1:700953207471:natgateway/nat-08aa89c9129079120-23",
    ResourceId:
      "arn:aws:ec2:us-east-1:700953207471:natgateway/nat-08aa89c9129079120-23",
    ResourceType: "aws.ec2.natgateway",
    ServiceName: "Amazon Elastic Compute Cloud",
    TotalCost: 212,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "ap-southeast-2",
    ResourceArn:
      "arn:aws:ec2:us-east-1:700953207471:natgateway/nat-08aa89c9129079120-24",
    ResourceId:
      "arn:aws:ec2:us-east-1:700953207471:natgateway/nat-08aa89c9129079120-24",
    ResourceType: "aws.ec2.natgateway",
    ServiceName: "Amazon Elastic Compute Cloud",
    TotalCost: 212,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: false,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "af-south-1",
    ResourceArn:
      "arn:aws:ec2:us-east-1:700953207471:natgateway/nat-08aa89c9129079120-25",
    ResourceId:
      "arn:aws:ec2:us-east-1:700953207471:natgateway/nat-08aa89c9129079120-25",
    ResourceType: "aws.ec2.natgateway",
    ServiceName: "Amazon Elastic Compute Cloud",
    TotalCost: 212,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: false,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "us-east-2",
    ResourceArn:
      "arn:aws:ec2:us-east-1:700953207471:natgateway/nat-08aa89c9129079120-26",
    ResourceId:
      "arn:aws:ec2:us-east-1:700953207471:natgateway/nat-08aa89c9129079120-26",
    ResourceType: "aws.ec2.natgateway",
    ServiceName: "Amazon Elastic Compute Cloud",
    TotalCost: 212,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: false,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "us-east-1",
    ResourceArn:
      "arn:aws:ec2:us-east-1:700953207471:natgateway/nat-08aa89c9129079120-27",
    ResourceId:
      "arn:aws:ec2:us-east-1:700953207471:natgateway/nat-08aa89c9129079120-27",
    ResourceType: "aws.ec2.natgateway",
    ServiceName: "Amazon Elastic Compute Cloud",
    TotalCost: 212,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: false,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "us-east-2",
    ResourceArn:
      "arn:aws:ec2:us-east-1:700953207471:natgateway/nat-08aa89c9129079120-28",
    ResourceId:
      "arn:aws:ec2:us-east-1:700953207471:natgateway/nat-08aa89c9129079120-28",
    ResourceType: "aws.ec2.natgateway",
    ServiceName: "Amazon Elastic Compute Cloud",
    TotalCost: 212,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: false,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "ap-northeast-1",
    ResourceArn:
      "arn:aws:ec2:us-east-1:700953207471:natgateway/nat-08aa89c9129079120-29",
    ResourceId:
      "arn:aws:ec2:us-east-1:700953207471:natgateway/nat-08aa89c9129079120-29",
    ResourceType: "aws.ec2.natgateway",
    ServiceName: "Amazon Elastic Compute Cloud",
    TotalCost: 212,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: false,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "ap-northeast-2",
    ResourceArn:
      "arn:aws:ec2:us-east-1:700953207471:natgateway/nat-08aa89c9129079120-30",
    ResourceId:
      "arn:aws:ec2:us-east-1:700953207471:natgateway/nat-08aa89c9129079120-30",
    ResourceType: "aws.ec2.natgateway",
    ServiceName: "Amazon Elastic Compute Cloud",
    TotalCost: 212,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: false,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "ap-northeast-2",
    ResourceArn:
      "arn:aws:ec2:us-east-1:700953207471:natgateway/nat-08aa89c9129079120-31",
    ResourceId:
      "arn:aws:ec2:us-east-1:700953207471:natgateway/nat-08aa89c9129079120-31",
    ResourceType: "aws.ec2.natgateway",
    ServiceName: "Amazon Elastic Compute Cloud",
    TotalCost: 212,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: false,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "ap-southeast-1",
    ResourceArn:
      "arn:aws:ec2:us-east-1:700953207471:natgateway/nat-08aa89c9129079120-32",
    ResourceId:
      "arn:aws:ec2:us-east-1:700953207471:natgateway/nat-08aa89c9129079120-32",
    ResourceType: "aws.ec2.natgateway",
    ServiceName: "Amazon Elastic Compute Cloud",
    TotalCost: 212,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: false,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "us-east-1",
    ResourceArn:
      "arn:aws:ec2:us-east-1:700953207471:natgateway/nat-08aa89c9129079120-33",
    ResourceId:
      "arn:aws:ec2:us-east-1:700953207471:natgateway/nat-08aa89c9129079120-33",
    ResourceType: "aws.ec2.natgateway",
    ServiceName: "Amazon Elastic Compute Cloud",
    TotalCost: 212,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: false,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "ap-southeast-3",
    ResourceArn:
      "arn:aws:ec2:us-east-1:700953207471:natgateway/nat-08aa89c9129079120-34",
    ResourceId:
      "arn:aws:ec2:us-east-1:700953207471:natgateway/nat-08aa89c9129079120-34",
    ResourceType: "aws.ec2.natgateway",
    ServiceName: "Amazon Elastic Compute Cloud",
    TotalCost: 212,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: false,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "us-east-2",
    ResourceArn:
      "arn:aws:ec2:us-east-1:700953207471:natgateway/nat-08aa89c9129079120-35",
    ResourceId:
      "arn:aws:ec2:us-east-1:700953207471:natgateway/nat-08aa89c9129079120-35",
    ResourceType: "aws.ec2.natgateway",
    ServiceName: "Amazon Elastic Compute Cloud",
    TotalCost: 212,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: false,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "ap-northeast-3",
    ResourceArn:
      "arn:aws:ec2:us-east-1:700953207471:natgateway/nat-08aa89c9129079120-36",
    ResourceId:
      "arn:aws:ec2:us-east-1:700953207471:natgateway/nat-08aa89c9129079120-36",
    ResourceType: "aws.ec2.natgateway",
    ServiceName: "Amazon Elastic Compute Cloud",
    TotalCost: 212,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: false,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "me-south-1",
    ResourceArn:
      "arn:aws:ec2:us-east-1:700953207471:natgateway/nat-08aa89c9129079120-37",
    ResourceId:
      "arn:aws:ec2:us-east-1:700953207471:natgateway/nat-08aa89c9129079120-37",
    ResourceType: "aws.ec2.natgateway",
    ServiceName: "Amazon Elastic Compute Cloud",
    TotalCost: 212,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: false,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "eu-west-3",
    ResourceArn:
      "arn:aws:ec2:us-east-1:700953207471:natgateway/nat-08aa89c9129079120-38",
    ResourceId:
      "arn:aws:ec2:us-east-1:700953207471:natgateway/nat-08aa89c9129079120-38",
    ResourceType: "aws.ec2.natgateway",
    ServiceName: "Amazon Elastic Compute Cloud",
    TotalCost: 212,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: false,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "ap-southeast-3",
    ResourceArn:
      "arn:aws:ec2:us-east-1:700953207471:natgateway/nat-08aa89c9129079120-39",
    ResourceId:
      "arn:aws:ec2:us-east-1:700953207471:natgateway/nat-08aa89c9129079120-39",
    ResourceType: "aws.ec2.natgateway",
    ServiceName: "Amazon Elastic Compute Cloud",
    TotalCost: 212,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: false,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "eu-west-2",
    ResourceArn:
      "arn:aws:ec2:us-east-1:700953207471:natgateway/nat-08aa89c9129079120-40",
    ResourceId:
      "arn:aws:ec2:us-east-1:700953207471:natgateway/nat-08aa89c9129079120-40",
    ResourceType: "aws.ec2.natgateway",
    ServiceName: "Amazon Elastic Compute Cloud",
    TotalCost: 212,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: false,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "eu-west-3",
    ResourceArn:
      "arn:aws:ec2:us-east-1:700953207471:natgateway/nat-08aa89c9129079120-41",
    ResourceId:
      "arn:aws:ec2:us-east-1:700953207471:natgateway/nat-08aa89c9129079120-41",
    ResourceType: "aws.ec2.natgateway",
    ServiceName: "Amazon Elastic Compute Cloud",
    TotalCost: 212,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: false,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "ap-northeast-3",
    ResourceArn:
      "arn:aws:ec2:us-east-1:700953207471:natgateway/nat-08aa89c9129079120-42",
    ResourceId:
      "arn:aws:ec2:us-east-1:700953207471:natgateway/nat-08aa89c9129079120-42",
    ResourceType: "aws.ec2.natgateway",
    ServiceName: "Amazon Elastic Compute Cloud",
    TotalCost: 212,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: false,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "ap-southeast-3",
    ResourceArn:
      "arn:aws:ec2:us-east-1:700953207471:natgateway/nat-08aa89c9129079120-43",
    ResourceId:
      "arn:aws:ec2:us-east-1:700953207471:natgateway/nat-08aa89c9129079120-43",
    ResourceType: "aws.ec2.natgateway",
    ServiceName: "Amazon Elastic Compute Cloud",
    TotalCost: 212,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: false,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "eu-north-1",
    ResourceArn:
      "arn:aws:ec2:us-east-1:700953207471:natgateway/nat-08aa89c9129079120-44",
    ResourceId:
      "arn:aws:ec2:us-east-1:700953207471:natgateway/nat-08aa89c9129079120-44",
    ResourceType: "aws.ec2.natgateway",
    ServiceName: "Amazon Elastic Compute Cloud",
    TotalCost: 212,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: false,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "eu-west-1",
    ResourceArn:
      "arn:aws:ec2:us-east-1:700953207471:natgateway/nat-08aa89c9129079120-45",
    ResourceId:
      "arn:aws:ec2:us-east-1:700953207471:natgateway/nat-08aa89c9129079120-45",
    ResourceType: "aws.ec2.natgateway",
    ServiceName: "Amazon Elastic Compute Cloud",
    TotalCost: 212,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: false,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "ca-central-1",
    ResourceArn:
      "arn:aws:ec2:us-east-1:700953207471:natgateway/nat-08aa89c9129079120-46",
    ResourceId:
      "arn:aws:ec2:us-east-1:700953207471:natgateway/nat-08aa89c9129079120-46",
    ResourceType: "aws.ec2.natgateway",
    ServiceName: "Amazon Elastic Compute Cloud",
    TotalCost: 212,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: false,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "af-south-1",
    ResourceArn:
      "arn:aws:ec2:us-east-1:700953207471:natgateway/nat-08aa89c9129079120-47",
    ResourceId:
      "arn:aws:ec2:us-east-1:700953207471:natgateway/nat-08aa89c9129079120-47",
    ResourceType: "aws.ec2.natgateway",
    ServiceName: "Amazon Elastic Compute Cloud",
    TotalCost: 212,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: false,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "ap-southeast-3",
    ResourceArn:
      "arn:aws:ec2:us-east-1:700953207471:natgateway/nat-08aa89c9129079120-48",
    ResourceId:
      "arn:aws:ec2:us-east-1:700953207471:natgateway/nat-08aa89c9129079120-48",
    ResourceType: "aws.ec2.natgateway",
    ServiceName: "Amazon Elastic Compute Cloud",
    TotalCost: 212,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: false,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "us-east-1",
    ResourceArn:
      "arn:aws:ec2:us-east-1:700953207471:natgateway/nat-08aa89c9129079120-49",
    ResourceId:
      "arn:aws:ec2:us-east-1:700953207471:natgateway/nat-08aa89c9129079120-49",
    ResourceType: "aws.ec2.natgateway",
    ServiceName: "Amazon Elastic Compute Cloud",
    TotalCost: 212,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: false,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "ap-southeast-3",
    ResourceArn:
      "arn:aws:ec2:us-east-1:700953207471:natgateway/nat-08aa89c9129079120-50",
    ResourceId:
      "arn:aws:ec2:us-east-1:700953207471:natgateway/nat-08aa89c9129079120-50",
    ResourceType: "aws.ec2.natgateway",
    ServiceName: "Amazon Elastic Compute Cloud",
    TotalCost: 212,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: false,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "eu-north-1",
    ResourceArn:
      "arn:aws:ec2:us-east-1:700953207471:natgateway/nat-08aa89c9129079120-51",
    ResourceId:
      "arn:aws:ec2:us-east-1:700953207471:natgateway/nat-08aa89c9129079120-51",
    ResourceType: "aws.ec2.natgateway",
    ServiceName: "Amazon Elastic Compute Cloud",
    TotalCost: 212,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: false,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "us-east-2",
    ResourceArn:
      "arn:aws:ec2:us-east-1:700953207471:natgateway/nat-08aa89c9129079120-52",
    ResourceId:
      "arn:aws:ec2:us-east-1:700953207471:natgateway/nat-08aa89c9129079120-52",
    ResourceType: "aws.ec2.natgateway",
    ServiceName: "Amazon Elastic Compute Cloud",
    TotalCost: 212,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: false,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "eu-west-1",
    ResourceArn:
      "arn:aws:ec2:us-east-1:700953207471:natgateway/nat-08aa89c9129079120-53",
    ResourceId:
      "arn:aws:ec2:us-east-1:700953207471:natgateway/nat-08aa89c9129079120-53",
    ResourceType: "aws.ec2.natgateway",
    ServiceName: "Amazon Elastic Compute Cloud",
    TotalCost: 212,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: false,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "me-south-1",
    ResourceArn:
      "arn:aws:ec2:us-east-1:700953207471:natgateway/nat-08aa89c9129079120-54",
    ResourceId:
      "arn:aws:ec2:us-east-1:700953207471:natgateway/nat-08aa89c9129079120-54",
    ResourceType: "aws.ec2.natgateway",
    ServiceName: "Amazon Elastic Compute Cloud",
    TotalCost: 212,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
];

const loadBalancer = [
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "us-east-2",
    ResourceArn:
      "arn:aws:elasticloadbalancing:us-east-1:700953207471:loadbalancer/app/mapappelb-700953207471/b982ae75eda8a1c9-0",
    ResourceId:
      "arn:aws:elasticloadbalancing:us-east-1:700953207471:loadbalancer/app/mapappelb-700953207471/b982ae75eda8a1c9-0",
    ResourceType: "aws.elasticloadbalancing.applicationloadbalancer",
    ServiceName: "Elastic Load Balancing",
    TotalCost: 240,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "ap-northeast-3",
    ResourceArn:
      "arn:aws:elasticloadbalancing:us-east-1:700953207471:loadbalancer/app/mapappelb-700953207471/b982ae75eda8a1c9-1",
    ResourceId:
      "arn:aws:elasticloadbalancing:us-east-1:700953207471:loadbalancer/app/mapappelb-700953207471/b982ae75eda8a1c9-1",
    ResourceType: "aws.elasticloadbalancing.applicationloadbalancer",
    ServiceName: "Elastic Load Balancing",
    TotalCost: 240,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "us-west-2",
    ResourceArn:
      "arn:aws:elasticloadbalancing:us-east-1:700953207471:loadbalancer/app/mapappelb-700953207471/b982ae75eda8a1c9-2",
    ResourceId:
      "arn:aws:elasticloadbalancing:us-east-1:700953207471:loadbalancer/app/mapappelb-700953207471/b982ae75eda8a1c9-2",
    ResourceType: "aws.elasticloadbalancing.applicationloadbalancer",
    ServiceName: "Elastic Load Balancing",
    TotalCost: 240,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "ap-northeast-3",
    ResourceArn:
      "arn:aws:elasticloadbalancing:us-east-1:700953207471:loadbalancer/app/mapappelb-700953207471/b982ae75eda8a1c9-3",
    ResourceId:
      "arn:aws:elasticloadbalancing:us-east-1:700953207471:loadbalancer/app/mapappelb-700953207471/b982ae75eda8a1c9-3",
    ResourceType: "aws.elasticloadbalancing.applicationloadbalancer",
    ServiceName: "Elastic Load Balancing",
    TotalCost: 240,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "eu-west-3",
    ResourceArn:
      "arn:aws:elasticloadbalancing:us-east-1:700953207471:loadbalancer/app/mapappelb-700953207471/b982ae75eda8a1c9-4",
    ResourceId:
      "arn:aws:elasticloadbalancing:us-east-1:700953207471:loadbalancer/app/mapappelb-700953207471/b982ae75eda8a1c9-4",
    ResourceType: "aws.elasticloadbalancing.applicationloadbalancer",
    ServiceName: "Elastic Load Balancing",
    TotalCost: 240,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: false,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "sa-east-1",
    ResourceArn:
      "arn:aws:elasticloadbalancing:us-east-1:700953207471:loadbalancer/app/mapappelb-700953207471/b982ae75eda8a1c9-5",
    ResourceId:
      "arn:aws:elasticloadbalancing:us-east-1:700953207471:loadbalancer/app/mapappelb-700953207471/b982ae75eda8a1c9-5",
    ResourceType: "aws.elasticloadbalancing.applicationloadbalancer",
    ServiceName: "Elastic Load Balancing",
    TotalCost: 240,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: false,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "eu-west-2",
    ResourceArn:
      "arn:aws:elasticloadbalancing:us-east-1:700953207471:loadbalancer/app/mapappelb-700953207471/b982ae75eda8a1c9-6",
    ResourceId:
      "arn:aws:elasticloadbalancing:us-east-1:700953207471:loadbalancer/app/mapappelb-700953207471/b982ae75eda8a1c9-6",
    ResourceType: "aws.elasticloadbalancing.applicationloadbalancer",
    ServiceName: "Elastic Load Balancing",
    TotalCost: 240,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: false,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "ca-central-1",
    ResourceArn:
      "arn:aws:elasticloadbalancing:us-east-1:700953207471:loadbalancer/app/mapappelb-700953207471/b982ae75eda8a1c9-7",
    ResourceId:
      "arn:aws:elasticloadbalancing:us-east-1:700953207471:loadbalancer/app/mapappelb-700953207471/b982ae75eda8a1c9-7",
    ResourceType: "aws.elasticloadbalancing.applicationloadbalancer",
    ServiceName: "Elastic Load Balancing",
    TotalCost: 240,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: false,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "us-east-1",
    ResourceArn:
      "arn:aws:elasticloadbalancing:us-east-1:700953207471:loadbalancer/app/mapappelb-700953207471/b982ae75eda8a1c9-8",
    ResourceId:
      "arn:aws:elasticloadbalancing:us-east-1:700953207471:loadbalancer/app/mapappelb-700953207471/b982ae75eda8a1c9-8",
    ResourceType: "aws.elasticloadbalancing.applicationloadbalancer",
    ServiceName: "Elastic Load Balancing",
    TotalCost: 240,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: false,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "ap-east-1",
    ResourceArn:
      "arn:aws:elasticloadbalancing:us-east-1:700953207471:loadbalancer/app/mapappelb-700953207471/b982ae75eda8a1c9-9",
    ResourceId:
      "arn:aws:elasticloadbalancing:us-east-1:700953207471:loadbalancer/app/mapappelb-700953207471/b982ae75eda8a1c9-9",
    ResourceType: "aws.elasticloadbalancing.applicationloadbalancer",
    ServiceName: "Elastic Load Balancing",
    TotalCost: 240,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: false,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "ap-east-1",
    ResourceArn:
      "arn:aws:elasticloadbalancing:us-east-1:700953207471:loadbalancer/app/mapappelb-700953207471/b982ae75eda8a1c9-10",
    ResourceId:
      "arn:aws:elasticloadbalancing:us-east-1:700953207471:loadbalancer/app/mapappelb-700953207471/b982ae75eda8a1c9-10",
    ResourceType: "aws.elasticloadbalancing.applicationloadbalancer",
    ServiceName: "Elastic Load Balancing",
    TotalCost: 240,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: false,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "ap-northeast-3",
    ResourceArn:
      "arn:aws:elasticloadbalancing:us-east-1:700953207471:loadbalancer/app/mapappelb-700953207471/b982ae75eda8a1c9-11",
    ResourceId:
      "arn:aws:elasticloadbalancing:us-east-1:700953207471:loadbalancer/app/mapappelb-700953207471/b982ae75eda8a1c9-11",
    ResourceType: "aws.elasticloadbalancing.applicationloadbalancer",
    ServiceName: "Elastic Load Balancing",
    TotalCost: 240,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: false,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "eu-south-1",
    ResourceArn:
      "arn:aws:elasticloadbalancing:us-east-1:700953207471:loadbalancer/app/mapappelb-700953207471/b982ae75eda8a1c9-12",
    ResourceId:
      "arn:aws:elasticloadbalancing:us-east-1:700953207471:loadbalancer/app/mapappelb-700953207471/b982ae75eda8a1c9-12",
    ResourceType: "aws.elasticloadbalancing.applicationloadbalancer",
    ServiceName: "Elastic Load Balancing",
    TotalCost: 240,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: false,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "sa-east-1",
    ResourceArn:
      "arn:aws:elasticloadbalancing:us-east-1:700953207471:loadbalancer/app/mapappelb-700953207471/b982ae75eda8a1c9-13",
    ResourceId:
      "arn:aws:elasticloadbalancing:us-east-1:700953207471:loadbalancer/app/mapappelb-700953207471/b982ae75eda8a1c9-13",
    ResourceType: "aws.elasticloadbalancing.applicationloadbalancer",
    ServiceName: "Elastic Load Balancing",
    TotalCost: 240,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
];

const glue = [
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "ap-northeast-2",
    ResourceArn: "arn:aws:glue:us-east-1:700953207471:crawler/testcrawler1-0",
    ResourceId: "arn:aws:glue:us-east-1:700953207471:crawler/testcrawler1-0",
    ResourceType: "aws.glue.crawler",
    ServiceName: "AWS Glue",
    TotalCost: 700,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "sa-east-1",
    ResourceArn: "arn:aws:glue:us-east-1:700953207471:crawler/testcrawler1-1",
    ResourceId: "arn:aws:glue:us-east-1:700953207471:crawler/testcrawler1-1",
    ResourceType: "aws.glue.crawler",
    ServiceName: "AWS Glue",
    TotalCost: 700,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "ap-northeast-3",
    ResourceArn: "arn:aws:glue:us-east-1:700953207471:crawler/testcrawler1-2",
    ResourceId: "arn:aws:glue:us-east-1:700953207471:crawler/testcrawler1-2",
    ResourceType: "aws.glue.crawler",
    ServiceName: "AWS Glue",
    TotalCost: 700,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
];

const cloudWatch = [
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "ap-northeast-1",
    ResourceArn:
      "arn:aws:cloudwatch:us-east-1:700953207471:insight-rule/MyInsightRule-0",
    ResourceId:
      "arn:aws:cloudwatch:us-east-1:700953207471:insight-rule/MyInsightRule-0",
    ResourceType: null,
    ServiceName: "AmazonCloudWatch",
    TotalCost: 25,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "eu-west-2",
    ResourceArn:
      "arn:aws:cloudwatch:us-east-1:700953207471:insight-rule/MyInsightRule-1",
    ResourceId:
      "arn:aws:cloudwatch:us-east-1:700953207471:insight-rule/MyInsightRule-1",
    ResourceType: null,
    ServiceName: "AmazonCloudWatch",
    TotalCost: 25,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "ap-southeast-1",
    ResourceArn:
      "arn:aws:cloudwatch:us-east-1:700953207471:insight-rule/MyInsightRule-2",
    ResourceId:
      "arn:aws:cloudwatch:us-east-1:700953207471:insight-rule/MyInsightRule-2",
    ResourceType: null,
    ServiceName: "AmazonCloudWatch",
    TotalCost: 25,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "us-east-2",
    ResourceArn:
      "arn:aws:cloudwatch:us-east-1:700953207471:insight-rule/MyInsightRule-3",
    ResourceId:
      "arn:aws:cloudwatch:us-east-1:700953207471:insight-rule/MyInsightRule-3",
    ResourceType: null,
    ServiceName: "AmazonCloudWatch",
    TotalCost: 25,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "ap-northeast-1",
    ResourceArn:
      "arn:aws:cloudwatch:us-east-1:700953207471:insight-rule/MyInsightRule-4",
    ResourceId:
      "arn:aws:cloudwatch:us-east-1:700953207471:insight-rule/MyInsightRule-4",
    ResourceType: null,
    ServiceName: "AmazonCloudWatch",
    TotalCost: 25,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "us-east-2",
    ResourceArn:
      "arn:aws:cloudwatch:us-east-1:700953207471:insight-rule/MyInsightRule-5",
    ResourceId:
      "arn:aws:cloudwatch:us-east-1:700953207471:insight-rule/MyInsightRule-5",
    ResourceType: null,
    ServiceName: "AmazonCloudWatch",
    TotalCost: 25,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "eu-west-2",
    ResourceArn:
      "arn:aws:cloudwatch:us-east-1:700953207471:insight-rule/MyInsightRule-6",
    ResourceId:
      "arn:aws:cloudwatch:us-east-1:700953207471:insight-rule/MyInsightRule-6",
    ResourceType: null,
    ServiceName: "AmazonCloudWatch",
    TotalCost: 25,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "sa-east-1",
    ResourceArn:
      "arn:aws:cloudwatch:us-east-1:700953207471:insight-rule/MyInsightRule-7",
    ResourceId:
      "arn:aws:cloudwatch:us-east-1:700953207471:insight-rule/MyInsightRule-7",
    ResourceType: null,
    ServiceName: "AmazonCloudWatch",
    TotalCost: 25,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "eu-north-1",
    ResourceArn:
      "arn:aws:cloudwatch:us-east-1:700953207471:insight-rule/MyInsightRule-8",
    ResourceId:
      "arn:aws:cloudwatch:us-east-1:700953207471:insight-rule/MyInsightRule-8",
    ResourceType: null,
    ServiceName: "AmazonCloudWatch",
    TotalCost: 25,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "eu-central-1",
    ResourceArn:
      "arn:aws:cloudwatch:us-east-1:700953207471:insight-rule/MyInsightRule-9",
    ResourceId:
      "arn:aws:cloudwatch:us-east-1:700953207471:insight-rule/MyInsightRule-9",
    ResourceType: null,
    ServiceName: "AmazonCloudWatch",
    TotalCost: 25,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: false,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "ap-southeast-2",
    ResourceArn:
      "arn:aws:cloudwatch:us-east-1:700953207471:insight-rule/MyInsightRule-10",
    ResourceId:
      "arn:aws:cloudwatch:us-east-1:700953207471:insight-rule/MyInsightRule-10",
    ResourceType: null,
    ServiceName: "AmazonCloudWatch",
    TotalCost: 25,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: false,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "ap-south-1",
    ResourceArn:
      "arn:aws:cloudwatch:us-east-1:700953207471:insight-rule/MyInsightRule-11",
    ResourceId:
      "arn:aws:cloudwatch:us-east-1:700953207471:insight-rule/MyInsightRule-11",
    ResourceType: null,
    ServiceName: "AmazonCloudWatch",
    TotalCost: 25,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: false,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "ap-southeast-3",
    ResourceArn:
      "arn:aws:cloudwatch:us-east-1:700953207471:insight-rule/MyInsightRule-12",
    ResourceId:
      "arn:aws:cloudwatch:us-east-1:700953207471:insight-rule/MyInsightRule-12",
    ResourceType: null,
    ServiceName: "AmazonCloudWatch",
    TotalCost: 25,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: false,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "sa-east-1",
    ResourceArn:
      "arn:aws:cloudwatch:us-east-1:700953207471:insight-rule/MyInsightRule-13",
    ResourceId:
      "arn:aws:cloudwatch:us-east-1:700953207471:insight-rule/MyInsightRule-13",
    ResourceType: null,
    ServiceName: "AmazonCloudWatch",
    TotalCost: 25,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: false,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "us-east-1",
    ResourceArn:
      "arn:aws:cloudwatch:us-east-1:700953207471:insight-rule/MyInsightRule-14",
    ResourceId:
      "arn:aws:cloudwatch:us-east-1:700953207471:insight-rule/MyInsightRule-14",
    ResourceType: null,
    ServiceName: "AmazonCloudWatch",
    TotalCost: 25,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: false,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "eu-west-2",
    ResourceArn:
      "arn:aws:cloudwatch:us-east-1:700953207471:insight-rule/MyInsightRule-15",
    ResourceId:
      "arn:aws:cloudwatch:us-east-1:700953207471:insight-rule/MyInsightRule-15",
    ResourceType: null,
    ServiceName: "AmazonCloudWatch",
    TotalCost: 25,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: false,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "us-west-1",
    ResourceArn:
      "arn:aws:cloudwatch:us-east-1:700953207471:insight-rule/MyInsightRule-16",
    ResourceId:
      "arn:aws:cloudwatch:us-east-1:700953207471:insight-rule/MyInsightRule-16",
    ResourceType: null,
    ServiceName: "AmazonCloudWatch",
    TotalCost: 25,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: false,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "ap-northeast-1",
    ResourceArn:
      "arn:aws:cloudwatch:us-east-1:700953207471:insight-rule/MyInsightRule-17",
    ResourceId:
      "arn:aws:cloudwatch:us-east-1:700953207471:insight-rule/MyInsightRule-17",
    ResourceType: null,
    ServiceName: "AmazonCloudWatch",
    TotalCost: 25,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: false,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "af-south-1",
    ResourceArn:
      "arn:aws:cloudwatch:us-east-1:700953207471:insight-rule/MyInsightRule-18",
    ResourceId:
      "arn:aws:cloudwatch:us-east-1:700953207471:insight-rule/MyInsightRule-18",
    ResourceType: null,
    ServiceName: "AmazonCloudWatch",
    TotalCost: 25,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: false,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "ap-south-1",
    ResourceArn:
      "arn:aws:cloudwatch:us-east-1:700953207471:insight-rule/MyInsightRule-19",
    ResourceId:
      "arn:aws:cloudwatch:us-east-1:700953207471:insight-rule/MyInsightRule-19",
    ResourceType: null,
    ServiceName: "AmazonCloudWatch",
    TotalCost: 25,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
];

const elasticache = [
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "ap-east-1",
    ResourceArn:
      "arn:aws:elasticache:us-east-1:700953207471:cluster:map-el-lat94w7anmq8-0",
    ResourceId:
      "arn:aws:elasticache:us-east-1:700953207471:cluster:map-el-lat94w7anmq8-0",
    ResourceType: "aws.elasticache.cluster",
    ServiceName: "Amazon ElastiCache",
    TotalCost: 176,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "eu-west-2",
    ResourceArn:
      "arn:aws:elasticache:us-east-1:700953207471:cluster:map-el-lat94w7anmq8-1",
    ResourceId:
      "arn:aws:elasticache:us-east-1:700953207471:cluster:map-el-lat94w7anmq8-1",
    ResourceType: "aws.elasticache.cluster",
    ServiceName: "Amazon ElastiCache",
    TotalCost: 176,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "eu-north-1",
    ResourceArn:
      "arn:aws:elasticache:us-east-1:700953207471:cluster:map-el-lat94w7anmq8-2",
    ResourceId:
      "arn:aws:elasticache:us-east-1:700953207471:cluster:map-el-lat94w7anmq8-2",
    ResourceType: "aws.elasticache.cluster",
    ServiceName: "Amazon ElastiCache",
    TotalCost: 176,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "af-south-1",
    ResourceArn:
      "arn:aws:elasticache:us-east-1:700953207471:cluster:map-el-lat94w7anmq8-3",
    ResourceId:
      "arn:aws:elasticache:us-east-1:700953207471:cluster:map-el-lat94w7anmq8-3",
    ResourceType: "aws.elasticache.cluster",
    ServiceName: "Amazon ElastiCache",
    TotalCost: 176,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "eu-west-1",
    ResourceArn:
      "arn:aws:elasticache:us-east-1:700953207471:cluster:map-el-lat94w7anmq8-4",
    ResourceId:
      "arn:aws:elasticache:us-east-1:700953207471:cluster:map-el-lat94w7anmq8-4",
    ResourceType: "aws.elasticache.cluster",
    ServiceName: "Amazon ElastiCache",
    TotalCost: 176,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: false,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "ap-northeast-1",
    ResourceArn:
      "arn:aws:elasticache:us-east-1:700953207471:cluster:map-el-lat94w7anmq8-5",
    ResourceId:
      "arn:aws:elasticache:us-east-1:700953207471:cluster:map-el-lat94w7anmq8-5",
    ResourceType: "aws.elasticache.cluster",
    ServiceName: "Amazon ElastiCache",
    TotalCost: 176,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: false,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "sa-east-1",
    ResourceArn:
      "arn:aws:elasticache:us-east-1:700953207471:cluster:map-el-lat94w7anmq8-6",
    ResourceId:
      "arn:aws:elasticache:us-east-1:700953207471:cluster:map-el-lat94w7anmq8-6",
    ResourceType: "aws.elasticache.cluster",
    ServiceName: "Amazon ElastiCache",
    TotalCost: 176,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
];

const redShift = [
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "us-west-2",
    ResourceArn:
      "arn:aws:redshift:us-east-1:700953207471:cluster:wartestredshiftncsec4-700953207471-0",
    ResourceId:
      "arn:aws:redshift:us-east-1:700953207471:cluster:wartestredshiftncsec4-700953207471-0",
    ResourceType: "aws.redshift.cluster",
    ServiceName: "Amazon Redshift",
    TotalCost: 250,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "ap-east-1",
    ResourceArn:
      "arn:aws:redshift:us-east-1:700953207471:cluster:wartestredshiftncsec4-700953207471-1",
    ResourceId:
      "arn:aws:redshift:us-east-1:700953207471:cluster:wartestredshiftncsec4-700953207471-1",
    ResourceType: "aws.redshift.cluster",
    ServiceName: "Amazon Redshift",
    TotalCost: 250,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "us-east-2",
    ResourceArn:
      "arn:aws:redshift:us-east-1:700953207471:cluster:wartestredshiftncsec4-700953207471-2",
    ResourceId:
      "arn:aws:redshift:us-east-1:700953207471:cluster:wartestredshiftncsec4-700953207471-2",
    ResourceType: "aws.redshift.cluster",
    ServiceName: "Amazon Redshift",
    TotalCost: 250,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
];

const dataPipeline = [
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "eu-north-1",
    ResourceArn:
      "arn:aws:datapipeline:us-east-1:700953207471:pipeline/df-01870033GXZXED4HIGBE-0",
    ResourceId:
      "arn:aws:datapipeline:us-east-1:700953207471:pipeline/df-01870033GXZXED4HIGBE-0",
    ResourceType: "aws.datapipeline.pipeline",
    ServiceName: "AWS Data Pipeline",
    TotalCost: 225,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "eu-north-1",
    ResourceArn:
      "arn:aws:datapipeline:us-east-1:700953207471:pipeline/df-01870033GXZXED4HIGBE-1",
    ResourceId:
      "arn:aws:datapipeline:us-east-1:700953207471:pipeline/df-01870033GXZXED4HIGBE-1",
    ResourceType: "aws.datapipeline.pipeline",
    ServiceName: "AWS Data Pipeline",
    TotalCost: 225,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: false,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "af-south-1",
    ResourceArn:
      "arn:aws:datapipeline:us-east-1:700953207471:pipeline/df-01870033GXZXED4HIGBE-2",
    ResourceId:
      "arn:aws:datapipeline:us-east-1:700953207471:pipeline/df-01870033GXZXED4HIGBE-2",
    ResourceType: "aws.datapipeline.pipeline",
    ServiceName: "AWS Data Pipeline",
    TotalCost: 225,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: false,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "eu-north-1",
    ResourceArn:
      "arn:aws:datapipeline:us-east-1:700953207471:pipeline/df-01870033GXZXED4HIGBE-3",
    ResourceId:
      "arn:aws:datapipeline:us-east-1:700953207471:pipeline/df-01870033GXZXED4HIGBE-3",
    ResourceType: "aws.datapipeline.pipeline",
    ServiceName: "AWS Data Pipeline",
    TotalCost: 225,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: false,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "us-east-2",
    ResourceArn:
      "arn:aws:datapipeline:us-east-1:700953207471:pipeline/df-01870033GXZXED4HIGBE-4",
    ResourceId:
      "arn:aws:datapipeline:us-east-1:700953207471:pipeline/df-01870033GXZXED4HIGBE-4",
    ResourceType: "aws.datapipeline.pipeline",
    ServiceName: "AWS Data Pipeline",
    TotalCost: 225,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: false,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "eu-west-2",
    ResourceArn:
      "arn:aws:datapipeline:us-east-1:700953207471:pipeline/df-01870033GXZXED4HIGBE-5",
    ResourceId:
      "arn:aws:datapipeline:us-east-1:700953207471:pipeline/df-01870033GXZXED4HIGBE-5",
    ResourceType: "aws.datapipeline.pipeline",
    ServiceName: "AWS Data Pipeline",
    TotalCost: 225,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: false,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "ap-northeast-2",
    ResourceArn:
      "arn:aws:datapipeline:us-east-1:700953207471:pipeline/df-01870033GXZXED4HIGBE-6",
    ResourceId:
      "arn:aws:datapipeline:us-east-1:700953207471:pipeline/df-01870033GXZXED4HIGBE-6",
    ResourceType: "aws.datapipeline.pipeline",
    ServiceName: "AWS Data Pipeline",
    TotalCost: 225,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: false,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "ap-northeast-2",
    ResourceArn:
      "arn:aws:datapipeline:us-east-1:700953207471:pipeline/df-01870033GXZXED4HIGBE-7",
    ResourceId:
      "arn:aws:datapipeline:us-east-1:700953207471:pipeline/df-01870033GXZXED4HIGBE-7",
    ResourceType: "aws.datapipeline.pipeline",
    ServiceName: "AWS Data Pipeline",
    TotalCost: 225,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: false,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "ap-southeast-1",
    ResourceArn:
      "arn:aws:datapipeline:us-east-1:700953207471:pipeline/df-01870033GXZXED4HIGBE-8",
    ResourceId:
      "arn:aws:datapipeline:us-east-1:700953207471:pipeline/df-01870033GXZXED4HIGBE-8",
    ResourceType: "aws.datapipeline.pipeline",
    ServiceName: "AWS Data Pipeline",
    TotalCost: 225,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: false,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "ap-southeast-1",
    ResourceArn:
      "arn:aws:datapipeline:us-east-1:700953207471:pipeline/df-01870033GXZXED4HIGBE-9",
    ResourceId:
      "arn:aws:datapipeline:us-east-1:700953207471:pipeline/df-01870033GXZXED4HIGBE-9",
    ResourceType: "aws.datapipeline.pipeline",
    ServiceName: "AWS Data Pipeline",
    TotalCost: 225,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: false,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "eu-west-2",
    ResourceArn:
      "arn:aws:datapipeline:us-east-1:700953207471:pipeline/df-01870033GXZXED4HIGBE-10",
    ResourceId:
      "arn:aws:datapipeline:us-east-1:700953207471:pipeline/df-01870033GXZXED4HIGBE-10",
    ResourceType: "aws.datapipeline.pipeline",
    ServiceName: "AWS Data Pipeline",
    TotalCost: 225,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: false,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "us-east-1",
    ResourceArn:
      "arn:aws:datapipeline:us-east-1:700953207471:pipeline/df-01870033GXZXED4HIGBE-11",
    ResourceId:
      "arn:aws:datapipeline:us-east-1:700953207471:pipeline/df-01870033GXZXED4HIGBE-11",
    ResourceType: "aws.datapipeline.pipeline",
    ServiceName: "AWS Data Pipeline",
    TotalCost: 225,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: false,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "us-east-2",
    ResourceArn:
      "arn:aws:datapipeline:us-east-1:700953207471:pipeline/df-01870033GXZXED4HIGBE-12",
    ResourceId:
      "arn:aws:datapipeline:us-east-1:700953207471:pipeline/df-01870033GXZXED4HIGBE-12",
    ResourceType: "aws.datapipeline.pipeline",
    ServiceName: "AWS Data Pipeline",
    TotalCost: 225,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: false,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "ap-northeast-1",
    ResourceArn:
      "arn:aws:datapipeline:us-east-1:700953207471:pipeline/df-01870033GXZXED4HIGBE-13",
    ResourceId:
      "arn:aws:datapipeline:us-east-1:700953207471:pipeline/df-01870033GXZXED4HIGBE-13",
    ResourceType: "aws.datapipeline.pipeline",
    ServiceName: "AWS Data Pipeline",
    TotalCost: 225,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: false,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "sa-east-1",
    ResourceArn:
      "arn:aws:datapipeline:us-east-1:700953207471:pipeline/df-01870033GXZXED4HIGBE-14",
    ResourceId:
      "arn:aws:datapipeline:us-east-1:700953207471:pipeline/df-01870033GXZXED4HIGBE-14",
    ResourceType: "aws.datapipeline.pipeline",
    ServiceName: "AWS Data Pipeline",
    TotalCost: 225,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: false,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "eu-central-1",
    ResourceArn:
      "arn:aws:datapipeline:us-east-1:700953207471:pipeline/df-01870033GXZXED4HIGBE-15",
    ResourceId:
      "arn:aws:datapipeline:us-east-1:700953207471:pipeline/df-01870033GXZXED4HIGBE-15",
    ResourceType: "aws.datapipeline.pipeline",
    ServiceName: "AWS Data Pipeline",
    TotalCost: 225,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: false,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "ap-south-1",
    ResourceArn:
      "arn:aws:datapipeline:us-east-1:700953207471:pipeline/df-01870033GXZXED4HIGBE-16",
    ResourceId:
      "arn:aws:datapipeline:us-east-1:700953207471:pipeline/df-01870033GXZXED4HIGBE-16",
    ResourceType: "aws.datapipeline.pipeline",
    ServiceName: "AWS Data Pipeline",
    TotalCost: 225,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: false,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "me-south-1",
    ResourceArn:
      "arn:aws:datapipeline:us-east-1:700953207471:pipeline/df-01870033GXZXED4HIGBE-17",
    ResourceId:
      "arn:aws:datapipeline:us-east-1:700953207471:pipeline/df-01870033GXZXED4HIGBE-17",
    ResourceType: "aws.datapipeline.pipeline",
    ServiceName: "AWS Data Pipeline",
    TotalCost: 225,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: false,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "eu-central-1",
    ResourceArn:
      "arn:aws:datapipeline:us-east-1:700953207471:pipeline/df-01870033GXZXED4HIGBE-18",
    ResourceId:
      "arn:aws:datapipeline:us-east-1:700953207471:pipeline/df-01870033GXZXED4HIGBE-18",
    ResourceType: "aws.datapipeline.pipeline",
    ServiceName: "AWS Data Pipeline",
    TotalCost: 225,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: false,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "eu-west-3",
    ResourceArn:
      "arn:aws:datapipeline:us-east-1:700953207471:pipeline/df-01870033GXZXED4HIGBE-19",
    ResourceId:
      "arn:aws:datapipeline:us-east-1:700953207471:pipeline/df-01870033GXZXED4HIGBE-19",
    ResourceType: "aws.datapipeline.pipeline",
    ServiceName: "AWS Data Pipeline",
    TotalCost: 225,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: false,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "ap-east-1",
    ResourceArn:
      "arn:aws:datapipeline:us-east-1:700953207471:pipeline/df-01870033GXZXED4HIGBE-20",
    ResourceId:
      "arn:aws:datapipeline:us-east-1:700953207471:pipeline/df-01870033GXZXED4HIGBE-20",
    ResourceType: "aws.datapipeline.pipeline",
    ServiceName: "AWS Data Pipeline",
    TotalCost: 225,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: false,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "ap-southeast-3",
    ResourceArn:
      "arn:aws:datapipeline:us-east-1:700953207471:pipeline/df-01870033GXZXED4HIGBE-21",
    ResourceId:
      "arn:aws:datapipeline:us-east-1:700953207471:pipeline/df-01870033GXZXED4HIGBE-21",
    ResourceType: "aws.datapipeline.pipeline",
    ServiceName: "AWS Data Pipeline",
    TotalCost: 225,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
];

const sns = [
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "ap-northeast-3",
    ResourceArn:
      "arn:aws:sns:ap-northeast-1:700953207471:MontyCloud-Automation-Task-Notification-Topic-0",
    ResourceId:
      "arn:aws:sns:ap-northeast-1:700953207471:MontyCloud-Automation-Task-Notification-Topic-0",
    ResourceType: "aws.sns.topic",
    ServiceName: "Amazon Simple Notification Service",
    TotalCost: 87.5,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "eu-west-2",
    ResourceArn:
      "arn:aws:sns:ap-northeast-1:700953207471:MontyCloud-Automation-Task-Notification-Topic-1",
    ResourceId:
      "arn:aws:sns:ap-northeast-1:700953207471:MontyCloud-Automation-Task-Notification-Topic-1",
    ResourceType: "aws.sns.topic",
    ServiceName: "Amazon Simple Notification Service",
    TotalCost: 87.5,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "ap-southeast-3",
    ResourceArn:
      "arn:aws:sns:ap-northeast-1:700953207471:MontyCloud-Automation-Task-Notification-Topic-2",
    ResourceId:
      "arn:aws:sns:ap-northeast-1:700953207471:MontyCloud-Automation-Task-Notification-Topic-2",
    ResourceType: "aws.sns.topic",
    ServiceName: "Amazon Simple Notification Service",
    TotalCost: 87.5,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "sa-east-1",
    ResourceArn:
      "arn:aws:sns:ap-northeast-1:700953207471:MontyCloud-Automation-Task-Notification-Topic-3",
    ResourceId:
      "arn:aws:sns:ap-northeast-1:700953207471:MontyCloud-Automation-Task-Notification-Topic-3",
    ResourceType: "aws.sns.topic",
    ServiceName: "Amazon Simple Notification Service",
    TotalCost: 87.5,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "eu-central-1",
    ResourceArn:
      "arn:aws:sns:ap-northeast-1:700953207471:MontyCloud-Automation-Task-Notification-Topic-4",
    ResourceId:
      "arn:aws:sns:ap-northeast-1:700953207471:MontyCloud-Automation-Task-Notification-Topic-4",
    ResourceType: "aws.sns.topic",
    ServiceName: "Amazon Simple Notification Service",
    TotalCost: 87.5,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "eu-north-1",
    ResourceArn:
      "arn:aws:sns:ap-northeast-1:700953207471:MontyCloud-Automation-Task-Notification-Topic-5",
    ResourceId:
      "arn:aws:sns:ap-northeast-1:700953207471:MontyCloud-Automation-Task-Notification-Topic-5",
    ResourceType: "aws.sns.topic",
    ServiceName: "Amazon Simple Notification Service",
    TotalCost: 87.5,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "us-west-1",
    ResourceArn:
      "arn:aws:sns:ap-northeast-1:700953207471:MontyCloud-Automation-Task-Notification-Topic-6",
    ResourceId:
      "arn:aws:sns:ap-northeast-1:700953207471:MontyCloud-Automation-Task-Notification-Topic-6",
    ResourceType: "aws.sns.topic",
    ServiceName: "Amazon Simple Notification Service",
    TotalCost: 87.5,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "ap-southeast-3",
    ResourceArn:
      "arn:aws:sns:ap-northeast-1:700953207471:MontyCloud-Automation-Task-Notification-Topic-7",
    ResourceId:
      "arn:aws:sns:ap-northeast-1:700953207471:MontyCloud-Automation-Task-Notification-Topic-7",
    ResourceType: "aws.sns.topic",
    ServiceName: "Amazon Simple Notification Service",
    TotalCost: 87.5,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
];

const dynamoDb = [
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "ap-northeast-1",
    ResourceArn:
      "arn:aws:dynamodb:us-east-1:700953207471:table/map-table1-a7426f00-1506-11ee-8be3-0a47f5e773a1-0",
    ResourceId:
      "arn:aws:dynamodb:us-east-1:700953207471:table/map-table1-a7426f00-1506-11ee-8be3-0a47f5e773a1-0",
    ResourceType: "aws.dynamodb.table",
    ServiceName: "Amazon DynamoDB",
    TotalCost: 130,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "ap-south-1",
    ResourceArn:
      "arn:aws:dynamodb:us-east-1:700953207471:table/map-table1-a7426f00-1506-11ee-8be3-0a47f5e773a1-1",
    ResourceId:
      "arn:aws:dynamodb:us-east-1:700953207471:table/map-table1-a7426f00-1506-11ee-8be3-0a47f5e773a1-1",
    ResourceType: "aws.dynamodb.table",
    ServiceName: "Amazon DynamoDB",
    TotalCost: 130,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "us-west-2",
    ResourceArn:
      "arn:aws:dynamodb:us-east-1:700953207471:table/map-table1-a7426f00-1506-11ee-8be3-0a47f5e773a1-2",
    ResourceId:
      "arn:aws:dynamodb:us-east-1:700953207471:table/map-table1-a7426f00-1506-11ee-8be3-0a47f5e773a1-2",
    ResourceType: "aws.dynamodb.table",
    ServiceName: "Amazon DynamoDB",
    TotalCost: 130,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "ap-southeast-3",
    ResourceArn:
      "arn:aws:dynamodb:us-east-1:700953207471:table/map-table1-a7426f00-1506-11ee-8be3-0a47f5e773a1-3",
    ResourceId:
      "arn:aws:dynamodb:us-east-1:700953207471:table/map-table1-a7426f00-1506-11ee-8be3-0a47f5e773a1-3",
    ResourceType: "aws.dynamodb.table",
    ServiceName: "Amazon DynamoDB",
    TotalCost: 130,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "us-west-1",
    ResourceArn:
      "arn:aws:dynamodb:us-east-1:700953207471:table/map-table1-a7426f00-1506-11ee-8be3-0a47f5e773a1-4",
    ResourceId:
      "arn:aws:dynamodb:us-east-1:700953207471:table/map-table1-a7426f00-1506-11ee-8be3-0a47f5e773a1-4",
    ResourceType: "aws.dynamodb.table",
    ServiceName: "Amazon DynamoDB",
    TotalCost: 130,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: false,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "me-south-1",
    ResourceArn:
      "arn:aws:dynamodb:us-east-1:700953207471:table/map-table1-a7426f00-1506-11ee-8be3-0a47f5e773a1-5",
    ResourceId:
      "arn:aws:dynamodb:us-east-1:700953207471:table/map-table1-a7426f00-1506-11ee-8be3-0a47f5e773a1-5",
    ResourceType: "aws.dynamodb.table",
    ServiceName: "Amazon DynamoDB",
    TotalCost: 130,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: false,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "ap-southeast-1",
    ResourceArn:
      "arn:aws:dynamodb:us-east-1:700953207471:table/map-table1-a7426f00-1506-11ee-8be3-0a47f5e773a1-6",
    ResourceId:
      "arn:aws:dynamodb:us-east-1:700953207471:table/map-table1-a7426f00-1506-11ee-8be3-0a47f5e773a1-6",
    ResourceType: "aws.dynamodb.table",
    ServiceName: "Amazon DynamoDB",
    TotalCost: 130,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: false,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "me-south-1",
    ResourceArn:
      "arn:aws:dynamodb:us-east-1:700953207471:table/map-table1-a7426f00-1506-11ee-8be3-0a47f5e773a1-7",
    ResourceId:
      "arn:aws:dynamodb:us-east-1:700953207471:table/map-table1-a7426f00-1506-11ee-8be3-0a47f5e773a1-7",
    ResourceType: "aws.dynamodb.table",
    ServiceName: "Amazon DynamoDB",
    TotalCost: 130,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: false,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "ap-southeast-3",
    ResourceArn:
      "arn:aws:dynamodb:us-east-1:700953207471:table/map-table1-a7426f00-1506-11ee-8be3-0a47f5e773a1-8",
    ResourceId:
      "arn:aws:dynamodb:us-east-1:700953207471:table/map-table1-a7426f00-1506-11ee-8be3-0a47f5e773a1-8",
    ResourceType: "aws.dynamodb.table",
    ServiceName: "Amazon DynamoDB",
    TotalCost: 130,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: false,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "ap-northeast-3",
    ResourceArn:
      "arn:aws:dynamodb:us-east-1:700953207471:table/map-table1-a7426f00-1506-11ee-8be3-0a47f5e773a1-9",
    ResourceId:
      "arn:aws:dynamodb:us-east-1:700953207471:table/map-table1-a7426f00-1506-11ee-8be3-0a47f5e773a1-9",
    ResourceType: "aws.dynamodb.table",
    ServiceName: "Amazon DynamoDB",
    TotalCost: 130,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: false,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "eu-central-1",
    ResourceArn:
      "arn:aws:dynamodb:us-east-1:700953207471:table/map-table1-a7426f00-1506-11ee-8be3-0a47f5e773a1-10",
    ResourceId:
      "arn:aws:dynamodb:us-east-1:700953207471:table/map-table1-a7426f00-1506-11ee-8be3-0a47f5e773a1-10",
    ResourceType: "aws.dynamodb.table",
    ServiceName: "Amazon DynamoDB",
    TotalCost: 130,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
];

const vpc = [
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "ap-southeast-2",
    ResourceArn:
      "arn:aws:ec2:us-east-1:700953207471:network-insights-analysis/nia-06a79b0f240d9d0bf-0",
    ResourceId:
      "arn:aws:ec2:us-east-1:700953207471:network-insights-analysis/nia-06a79b0f240d9d0bf-0",
    ResourceType: null,
    ServiceName: "Amazon Virtual Private Cloud",
    TotalCost: 82,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "eu-central-1",
    ResourceArn:
      "arn:aws:ec2:us-east-1:700953207471:network-insights-analysis/nia-06a79b0f240d9d0bf-1",
    ResourceId:
      "arn:aws:ec2:us-east-1:700953207471:network-insights-analysis/nia-06a79b0f240d9d0bf-1",
    ResourceType: null,
    ServiceName: "Amazon Virtual Private Cloud",
    TotalCost: 82,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "me-south-1",
    ResourceArn:
      "arn:aws:ec2:us-east-1:700953207471:network-insights-analysis/nia-06a79b0f240d9d0bf-2",
    ResourceId:
      "arn:aws:ec2:us-east-1:700953207471:network-insights-analysis/nia-06a79b0f240d9d0bf-2",
    ResourceType: null,
    ServiceName: "Amazon Virtual Private Cloud",
    TotalCost: 82,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "eu-central-1",
    ResourceArn:
      "arn:aws:ec2:us-east-1:700953207471:network-insights-analysis/nia-06a79b0f240d9d0bf-3",
    ResourceId:
      "arn:aws:ec2:us-east-1:700953207471:network-insights-analysis/nia-06a79b0f240d9d0bf-3",
    ResourceType: null,
    ServiceName: "Amazon Virtual Private Cloud",
    TotalCost: 82,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "af-south-1",
    ResourceArn:
      "arn:aws:ec2:us-east-1:700953207471:network-insights-analysis/nia-06a79b0f240d9d0bf-4",
    ResourceId:
      "arn:aws:ec2:us-east-1:700953207471:network-insights-analysis/nia-06a79b0f240d9d0bf-4",
    ResourceType: null,
    ServiceName: "Amazon Virtual Private Cloud",
    TotalCost: 82,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: false,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "ap-east-1",
    ResourceArn:
      "arn:aws:ec2:us-east-1:700953207471:network-insights-analysis/nia-06a79b0f240d9d0bf-5",
    ResourceId:
      "arn:aws:ec2:us-east-1:700953207471:network-insights-analysis/nia-06a79b0f240d9d0bf-5",
    ResourceType: null,
    ServiceName: "Amazon Virtual Private Cloud",
    TotalCost: 82,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: false,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "af-south-1",
    ResourceArn:
      "arn:aws:ec2:us-east-1:700953207471:network-insights-analysis/nia-06a79b0f240d9d0bf-6",
    ResourceId:
      "arn:aws:ec2:us-east-1:700953207471:network-insights-analysis/nia-06a79b0f240d9d0bf-6",
    ResourceType: null,
    ServiceName: "Amazon Virtual Private Cloud",
    TotalCost: 82,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: false,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "ap-southeast-1",
    ResourceArn:
      "arn:aws:ec2:us-east-1:700953207471:network-insights-analysis/nia-06a79b0f240d9d0bf-7",
    ResourceId:
      "arn:aws:ec2:us-east-1:700953207471:network-insights-analysis/nia-06a79b0f240d9d0bf-7",
    ResourceType: null,
    ServiceName: "Amazon Virtual Private Cloud",
    TotalCost: 82,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: false,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "us-west-2",
    ResourceArn:
      "arn:aws:ec2:us-east-1:700953207471:network-insights-analysis/nia-06a79b0f240d9d0bf-8",
    ResourceId:
      "arn:aws:ec2:us-east-1:700953207471:network-insights-analysis/nia-06a79b0f240d9d0bf-8",
    ResourceType: null,
    ServiceName: "Amazon Virtual Private Cloud",
    TotalCost: 82,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: false,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "ap-southeast-1",
    ResourceArn:
      "arn:aws:ec2:us-east-1:700953207471:network-insights-analysis/nia-06a79b0f240d9d0bf-9",
    ResourceId:
      "arn:aws:ec2:us-east-1:700953207471:network-insights-analysis/nia-06a79b0f240d9d0bf-9",
    ResourceType: null,
    ServiceName: "Amazon Virtual Private Cloud",
    TotalCost: 82,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: false,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "us-west-1",
    ResourceArn:
      "arn:aws:ec2:us-east-1:700953207471:network-insights-analysis/nia-06a79b0f240d9d0bf-10",
    ResourceId:
      "arn:aws:ec2:us-east-1:700953207471:network-insights-analysis/nia-06a79b0f240d9d0bf-10",
    ResourceType: null,
    ServiceName: "Amazon Virtual Private Cloud",
    TotalCost: 82,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
];

const cloudshell = [
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "ap-northeast-1",
    ResourceArn:
      "arn:aws:sts::700953207471:assumed-role/AWSReservedSSO_AdministratorAccess_e2a482c045ad414a/Cibi+CustomerSimulation-0",
    ResourceId:
      "arn:aws:sts::700953207471:assumed-role/AWSReservedSSO_AdministratorAccess_e2a482c045ad414a/Cibi+CustomerSimulation-0",
    ResourceType: "aws.cloudshell.assumed-role",
    ServiceName: "AWS CloudShell",
    TotalCost: 120,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: true,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "ap-southeast-2",
    ResourceArn:
      "arn:aws:sts::700953207471:assumed-role/AWSReservedSSO_AdministratorAccess_e2a482c045ad414a/Cibi+CustomerSimulation-1",
    ResourceId:
      "arn:aws:sts::700953207471:assumed-role/AWSReservedSSO_AdministratorAccess_e2a482c045ad414a/Cibi+CustomerSimulation-1",
    ResourceType: "aws.cloudshell.assumed-role",
    ServiceName: "AWS CloudShell",
    TotalCost: 120,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: false,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "me-south-1",
    ResourceArn:
      "arn:aws:sts::700953207471:assumed-role/AWSReservedSSO_AdministratorAccess_e2a482c045ad414a/Cibi+CustomerSimulation-2",
    ResourceId:
      "arn:aws:sts::700953207471:assumed-role/AWSReservedSSO_AdministratorAccess_e2a482c045ad414a/Cibi+CustomerSimulation-2",
    ResourceType: "aws.cloudshell.assumed-role",
    ServiceName: "AWS CloudShell",
    TotalCost: 120,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: false,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "eu-central-1",
    ResourceArn:
      "arn:aws:sts::700953207471:assumed-role/AWSReservedSSO_AdministratorAccess_e2a482c045ad414a/Cibi+CustomerSimulation-3",
    ResourceId:
      "arn:aws:sts::700953207471:assumed-role/AWSReservedSSO_AdministratorAccess_e2a482c045ad414a/Cibi+CustomerSimulation-3",
    ResourceType: "aws.cloudshell.assumed-role",
    ServiceName: "AWS CloudShell",
    TotalCost: 120,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: false,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "sa-east-1",
    ResourceArn:
      "arn:aws:sts::700953207471:assumed-role/AWSReservedSSO_AdministratorAccess_e2a482c045ad414a/Cibi+CustomerSimulation-4",
    ResourceId:
      "arn:aws:sts::700953207471:assumed-role/AWSReservedSSO_AdministratorAccess_e2a482c045ad414a/Cibi+CustomerSimulation-4",
    ResourceType: "aws.cloudshell.assumed-role",
    ServiceName: "AWS CloudShell",
    TotalCost: 120,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: false,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "me-south-1",
    ResourceArn:
      "arn:aws:sts::700953207471:assumed-role/AWSReservedSSO_AdministratorAccess_e2a482c045ad414a/Cibi+CustomerSimulation-5",
    ResourceId:
      "arn:aws:sts::700953207471:assumed-role/AWSReservedSSO_AdministratorAccess_e2a482c045ad414a/Cibi+CustomerSimulation-5",
    ResourceType: "aws.cloudshell.assumed-role",
    ServiceName: "AWS CloudShell",
    TotalCost: 120,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: false,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "af-south-1",
    ResourceArn:
      "arn:aws:sts::700953207471:assumed-role/AWSReservedSSO_AdministratorAccess_e2a482c045ad414a/Cibi+CustomerSimulation-6",
    ResourceId:
      "arn:aws:sts::700953207471:assumed-role/AWSReservedSSO_AdministratorAccess_e2a482c045ad414a/Cibi+CustomerSimulation-6",
    ResourceType: "aws.cloudshell.assumed-role",
    ServiceName: "AWS CloudShell",
    TotalCost: 120,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
  {
    AccountNumber: "700953207471",
    CreatedOn: null,
    CurrencyCode: "USD",
    IsTagged: false,
    MapProjectId: "a6459a0d-25b8-4f84-b966-846c2f5f1e1e",
    ModifiedOn: null,
    OrganizationId: "beb0378d-b14c-4ddd-ab34-ce9d5a6b68cc",
    PayerAccountId: "302696813624",
    RegionCode: "eu-west-2",
    ResourceArn:
      "arn:aws:sts::700953207471:assumed-role/AWSReservedSSO_AdministratorAccess_e2a482c045ad414a/Cibi+CustomerSimulation-7",
    ResourceId:
      "arn:aws:sts::700953207471:assumed-role/AWSReservedSSO_AdministratorAccess_e2a482c045ad414a/Cibi+CustomerSimulation-7",
    ResourceType: "aws.cloudshell.assumed-role",
    ServiceName: "AWS CloudShell",
    TotalCost: 120,
    TotalCostTagged: null,
    TotalCostUntagged: null,
  },
];

export const RESOURCE_MASTER_OBJ = {
  "Amazon Simple Storage Service": AWS_S3,
  "AWS Security Hub": AWS_Security_Hub,
  "Amazon FSx": FSX,
  "Amazon Elastic Container Service for Kubernetes": AWS_ECS_Kubernetes,
  "Amazon Elastic Container Service": AWS_ECS,
  "AWS Network Firewall": networkFirewall,
  "Amazon Neptune": neptune,
  "Amazon Relational Database Service": rds,
  "Amazon Route 53": route53,
  "Amazon Comprehend": comprehend,
  "Amazon Elastic MapReduce": mapReduce,
  "Amazon Managed Streaming for Apache Kafka": kafka,
  "Amazon SageMaker": sageMaker,
  "AWS Database Migration Service": dms,
  "Amazon OpenSearch Service": openSearch,
  "AWS Systems Manager": systemsManager,
  "AWS Secrets Manager": secretsManager,
  "Amazon AppStream": appStream,
  "AWS Key Management Service": kms,
  "Amazon API Gateway": apiGateway,
  "AWS Lambda": lambda,
  "Amazon Elastic File System": efs,
  "Amazon Kinesis": kinesis,
  "Amazon Elastic Compute Cloud": ec2,
  "Elastic Load Balancing": loadBalancer,
  "AWS Glue": glue,
  AmazonCloudWatch: cloudWatch,
  "Amazon ElastiCache": elasticache,
  "Amazon Redshift": redShift,
  "AWS Data Pipeline": dataPipeline,
  "Amazon Simple Notification Service": sns,
  "Amazon DynamoDB": dynamoDb,
  "Amazon Virtual Private Cloud": vpc,
  "AWS CloudShell": cloudshell,
};
